{
  "notice": {
    "pro": {
      "ai_visibility": {
        "title": "New: AI Visibility",
        "body": "Track how your brand shows up in ChatGPT, Perplexity, and Google AI Overviews.",
        "primary": "Open AI Visibility",
        "secondary": "Maybe later"
      }
    }
  },
  "nav": {
    "overview": "Overview",
    "review": "Review",
    "brands": "Brands",
    "analytics": "Analytics",
    "aiVisibility": "AI Visibility",
    "engagement": "Engagement",
    "ads": "Ads",
    "calendar": "Calendar",
    "discover": "Discover",
    "posts": "Posts",
    "usage": "Usage",
    "settings": "Settings",
    "general": "General",
    "profile": "Profile",
    "members": "Members",
    "connections": "Connections",
    "connectedApps": "Connected Apps",
    "cadence": "Cadence",
    "carouselTemplates": "Carousel templates",
    "reports": "Reports",
    "autoResponses": "Auto-responses",
    "billing": "Billing",
    "privacy": "Privacy",
    "privacyData": "Privacy & data",
    "storylines": "Storylines",
    "blog": "Blog"
  },
  "sidebar": {
    "sectionMain": "MAIN",
    "sectionContent": "CONTENT",
    "sectionGrowth": "GROWTH",
    "sectionSettings": "SETTINGS",
    "sectionAdmin": "ADMIN"
  },
  "topbar": {
    "searchPlaceholder": "Search posts, brands, connections...",
    "searchNoResults": "No results for \"{{query}}\"",
    "searchPage": "Page",
    "searchBrand": "Brand",
    "notifications": "Notifications",
    "notificationsUnread": "Notifications — {{count}} unread",
    "accountMenu": "Account menu",
    "accountFallback": "Account"
  },
  "dashboard": {
    "greeting": "Good morning,",
    "greetingAfternoon": "Good afternoon,",
    "greetingEvening": "Good evening,",
    "postsWaitingReview": "You have <strong>{{count}}</strong> posts waiting for review",
    "unreadInboxItems_one": "and <strong>{{count}}</strong> unread inbox item",
    "unreadInboxItems_other": "and <strong>{{count}}</strong> unread inbox items",
    "allCaughtUp": "You're all caught up. Great work!",
    "generatePost": "Generate post",
    "generateBlog": "Generate blog",
    "generate": "Generate",
    "writePost": "Write post",
    "engage": "Engage",
    "postsPublishedChart": "Posts published",
    "last30DaysByPlatform": "Last 30 days by platform",
    "platformSplit": "Platform split",
    "postsByPlatform": "Posts by platform",
    "recentPosts": "Recent posts",
    "latestActivity": "Latest activity across all platforms",
    "liveActivity": "Live activity",
    "viewReports": "View reports",
    "noDataYet": "No platform data yet",
    "firstPostsMonday": "Merkflow generates your first posts on Monday.",
    "noRecentPosts": "No recent posts yet",
    "youHave": "You have",
    "pendingPostsCount_one": "{{count}} post waiting for review",
    "pendingPostsCount_other": "{{count}} posts waiting for review",
    "unreadInboxCount_one": "{{count}} unread inbox item",
    "unreadInboxCount_other": "{{count}} unread inbox items",
    "someone": "Someone"
  },
  "join": {
    "loading": "Checking your invite…",
    "subtitle": "You've been invited to try Merkflow",
    "invitedMessage": "Merkflow helps you manage social media across multiple brands with AI. Create your account below to get started.",
    "bypassFailed": "We couldn't validate your invite. Try the link again or ask the person who shared it.",
    "invalid": {
      "title": "Invite link not valid",
      "expired": "This invite link has expired. Contact the person who shared it for a new one.",
      "maxed": "This invite link has reached its maximum number of uses.",
      "disabled": "This invite link is no longer active.",
      "not_found": "We couldn't find an invite link with that code. Double-check the URL."
    }
  },
  "feedback": {
    "button": "Feedback",
    "title": "Send feedback",
    "category": "Category",
    "category.bug": "Bug",
    "category.feature_request": "Feature",
    "category.general": "General",
    "category.question": "Question",
    "titleField": "Title",
    "titlePlaceholder": "Short summary of what you want to report",
    "description": "Description",
    "descriptionPlaceholder": "Steps to reproduce, what you expected, what happened…",
    "screenshot": "Screenshot (optional)",
    "attachScreenshot": "Attach screenshot",
    "captureScreen": "Capture screen",
    "capturing": "Capturing…",
    "captureFailed": "Couldn't capture the screen. Try uploading an image instead.",
    "uploadImage": "Upload image",
    "screenshotAttached": "Screenshot attached",
    "pageContext": "Reporting from {{path}}",
    "submit": "Send feedback",
    "rateLimited": "You've hit the daily feedback limit. Try again tomorrow.",
    "disabled": "Feedback is currently disabled.",
    "success": {
      "title": "Thanks for your feedback!",
      "message": "We'll take a look and get back to you if we need more details."
    }
  },
  "waitlisted": {
    "title": "You're on the waiting list",
    "description": "Thanks for signing up and completing your profile — everything is saved. Registration is invite-only right now, so your account isn't active yet. We'll email you as soon as a spot opens up and your trial begins."
  },
  "waitlist": {
    "title": "Request early access",
    "subtitle": "Registration is currently invite-only. Leave your details and we'll let you know when a spot opens up.",
    "name": "Full name *",
    "email": "Email *",
    "company": "Company",
    "useCase": "What will you use Merkflow for?",
    "submit": "Request access",
    "success": {
      "title": "You're on the list!",
      "message": "We'll email you at {{email}} when your access is ready."
    },
    "duplicate": "You've already requested access. We'll be in touch.",
    "rateLimited": "Too many requests from this network. Try again in an hour."
  },
  "starterGate": {
    "upgradeCta": "Upgrade to Pro",
    "analytics": {
      "title": "Analytics is a Pro feature",
      "description": "Detailed performance reports, per-platform breakdowns, and engagement trends become available when you upgrade."
    },
    "aiVisibility": {
      "title": "AI Visibility is a Pro feature",
      "description": "See how ChatGPT, Perplexity, and Google AI Overviews talk about your brand. Run probes, fix gaps, and track your AI search score on Pro."
    },
    "ads": {
      "title": "Meta Ads is a Pro feature",
      "description": "Create and manage Facebook + Instagram ad campaigns from within Merkflow on Pro."
    },
    "storylines": {
      "title": "Storylines is a Pro feature",
      "description": "Plan multi-week narrative arcs across your channels. Available on Pro."
    },
    "calendar": {
      "title": "Calendar view is a Pro feature",
      "description": "Visual monthly calendar across all your brands and platforms. Available on Pro."
    },
    "discover": {
      "title": "Discover is a Pro feature",
      "description": "Trending topics, market intel, and competitor benchmarking. Available on Pro."
    },
    "blog": {
      "title": "Blog generation is a Pro feature",
      "description": "Auto-generate WordPress blog drafts to boost your AI search visibility. Available on Pro."
    },
    "usage": {
      "title": "Usage analytics is a Pro feature",
      "description": "Detailed AI cost breakdowns by model, brand, and operation. Available on Pro."
    }
  },
  "starterOverview": {
    "generateHint": "Let AI write your next post",
    "writeHint": "Compose a post yourself",
    "reviewQueue": "Posts ready for your review"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "notNow": "Not now",
    "upgradeToUnlock": "Upgrade to unlock",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "loading": "Loading...",
    "loadingShort": "Loading…",
    "confirm": "Confirm",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "search": "Search",
    "noResults": "No results found",
    "required": "Required",
    "optional": "Optional",
    "learnMore": "Learn more",
    "viewAll": "View all",
    "refresh": "Refresh",
    "retry": "Retry",
    "enable": "Enable",
    "disable": "Disable",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "weekdays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "active": "Active",
    "inactive": "Inactive",
    "yes": "Yes",
    "no": "No",
    "or": "or",
    "and": "and",
    "copied": "Copied!",
    "copy": "Copy",
    "select": "Select",
    "all": "All",
    "loadMore": "Load more",
    "saveChanges": "Save changes",
    "discard": "Discard",
    "areYouSure": "Are you sure?",
    "remove": "Remove",
    "uploading": "Uploading…",
    "pending": "Pending",
    "rejected": "Rejected",
    "saved": "Saved",
    "saving": "Saving…",
    "sending": "Sending…",
    "testing": "Testing…",
    "filter": "Filter",
    "create": "Create",
    "createBrand": "Create brand",
    "connect": "Connect",
    "connected": "Connected",
    "notConnected": "Not connected",
    "done": "Done",
    "comingSoon": "Coming soon",
    "today": "Today",
    "failed": "Failed",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "backToSignIn": "Back to sign in",
    "backToDashboard": "Back to dashboard",
    "nevermind": "Never mind",
    "inWord": "in",
    "youSuffix": "(you)",
    "google": "Google",
    "undo": "Undo",
    "redo": "Redo",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "platforms": "Platforms",
    "recently": "recently",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "openMenu": "Open menu",
    "errorTitle": "Something went wrong"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection.",
    "unauthorized": "You are not authorized to do this.",
    "notFound": "Not found.",
    "validation": "Please check the form for errors.",
    "serverError": "Server error. We're on it.",
    "forbidden": "You don't have access to this.",
    "ownerOnly": "Only the workspace owner can do this.",
    "featureNotAvailable": "Upgrade to access this feature",
    "featureUpgradeHint": "This feature is on a higher plan. Compare plans or upgrade now to unlock it.",
    "viewPlans": "View plans",
    "trialExpired": "Your trial has expired. Please upgrade to continue.",
    "trialExpiredTooltip": "Your trial has ended — upgrade to keep creating posts.",
    "workspacePausedTooltip": "This workspace is paused — upgrade or resubscribe to continue.",
    "planLimit": "Your plan doesn't support this feature.",
    "publishFailed": "Failed to publish post.",
    "connectionExpired": "Connection expired. Please reconnect your account.",
    "disconnectFailed": "Disconnect failed.",
    "saveFailed": "Failed to save. Try again.",
    "loginFailed": "Login failed. Please try again.",
    "verificationEmailFailed": "Could not send verification email. Try again later.",
    "workspaceCreationFailed": "Could not create workspace. Try again.",
    "createWorkspaceFailed": "Could not create workspace (HTTP {{status}}).",
    "createWorkspaceGeneric": "Could not create workspace. Try again.",
    "chunkLoadError": "Something went wrong",
    "chunkLoadHelp": "Try refreshing the page. If the problem persists, sign out and back in.",
    "reload": "Reload",
    "unexpectedTitle": "Something went wrong",
    "unexpectedHelp": "This page hit an unexpected error. Try again, or reload if it keeps happening.",
    "tryAgain": "Try again"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "signInWithGoogle": "Sign in with Google",
    "signInTitle": "Sign in to Merkflow",
    "signInSubtitle": "Sign in to your Merkflow account",
    "continueWithGoogle": "Continue with Google",
    "continueWithLinkedIn": "Continue with LinkedIn",
    "welcomeBack": "Welcome back",
    "email": "Email address",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "noAccount": "Don't have an account?",
    "alreadyAccount": "Already have an account?",
    "register": "Create account",
    "createAccount": "Create account",
    "createAccountSubtitle": "Create your Merkflow account",
    "emailVerified": "Email verified. You can now sign in.",
    "verificationEmailSent": "Verification email sent! Check your inbox.",
    "startFreeTrial": "Start your free trial",
    "resendVerificationEmail": "Resend verification email",
    "passwordValidation": "Password must be at least 8 characters and contain a number.",
    "passwordRequirements": "Min. 8 characters with at least one number",
    "trialInfo": "{{days}}-day free trial. No credit card required.",
    "registrationClosed": {
      "title": "Registration closed",
      "message": "We're not accepting new signups right now. If you've been invited to test, check your email for an invitation link."
    },
    "checkEmail": "Check your email",
    "verificationSentTo": "We sent a verification link to",
    "verifyAccount": "Click it to verify your account and get started.",
    "fullName": "Full name",
    "forgotPasswordSubtitle": "Forgot your password?",
    "forgotPasswordDescription": "Enter your email and we'll send you a link to reset it.",
    "sendResetLink": "Send reset link",
    "resetLinkSent": "If an account exists for",
    "resetLinkSentDesc": "we've sent a password reset link.",
    "setNewPassword": "Set a new password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "passwordsMismatch": "Passwords do not match",
    "invalidResetToken": "Invalid or missing reset token.",
    "resetPassword": "Reset password",
    "invalidResetLink": "Invalid reset link",
    "resetLinkExpired": "This password reset link is invalid or has expired.",
    "requestNewLink": "Request a new link"
  },
  "settings": {
    "title": "Settings",
    "language": "Interface language",
    "languageDescription": "Choose the language for the Merkflow interface.",
    "dutch": "Dutch",
    "english": "English",
    "languageSaved": "Language updated.",
    "general": "General",
    "approval": {
      "title": "Approval notifications",
      "description": "Send an email when new posts are ready for review. Add the addresses that should get notified — leaving the list empty falls back to the workspace owner.",
      "addEmail": "Add email address",
      "saved": "Notification preferences saved",
      "emptyHint": "No recipients yet — the workspace owner email will be used as fallback.",
      "smtpMissing": "No SMTP is configured for this workspace and there is no platform-wide fallback. Recipients you add here won't receive emails until SMTP is set up under Settings → Connected apps → Email, or an admin configures the global SMTP."
    },
    "showcase": {
      "title": "Public showcase",
      "label": "Let Merkflow feature my posts on the website",
      "help": "When on, recently published posts from this workspace can appear in the public showcase on merkflow.eu. Only posts generated by Merkflow — never synced third-party posts. You can turn this off at any time.",
      "saved": "Showcase preference saved"
    },
    "autoResponses": {
      "title": "Auto-responses",
      "subtitle": "Automatically reply to comments and mentions based on rules.",
      "create": "Create rule",
      "edit": "Edit rule",
      "save": "Save rule",
      "name": "Rule name",
      "namePlaceholder": "e.g. Pricing replies",
      "brand": "Brand",
      "allBrands": "All brands",
      "allPlatforms": "All platforms",
      "platforms": "Platforms",
      "platformsHint": "Leave empty to apply to every connected platform.",
      "triggerLabel": "Trigger",
      "trigger": {
        "keyword": "Contains keyword",
        "sentiment": "Sentiment is",
        "all": "All comments",
        "keywordWith": "Keyword: {{keywords}}",
        "sentimentWith": "Sentiment is {{sentiment}}"
      },
      "keywordPlaceholder": "pricing, cost, plan",
      "selectSentiment": "Choose sentiment",
      "sentiment": {
        "positive": "Positive",
        "neutral": "Neutral",
        "negative": "Negative",
        "question": "Question"
      },
      "responseLabel": "Response",
      "response": {
        "template": "Fixed reply",
        "ai": "Use AI suggestion"
      },
      "templatePlaceholder": "Thanks for reaching out! We'll be in touch shortly.",
      "aiHint": "Uses the AI-generated reply suggestion stored alongside each comment.",
      "requireReview": "Review before sending",
      "maxPerHour": "Max replies per hour",
      "maxPerHourHint": "Per-rule rate limit. Default 10. Prevents runaway replies if a post goes viral.",
      "repliesSent_one": "{{count}} reply sent",
      "repliesSent_other": "{{count}} replies sent",
      "deleteConfirmTitle": "Delete this rule?",
      "deleteConfirmMessage": "{{name}} will stop firing. Past auto-replies stay in the audit log.",
      "deleted": "Rule deleted",
      "empty": {
        "title": "No auto-responses yet",
        "description": "Reply automatically to comments matching keywords or sentiment."
      },
      "errors": {
        "nameRequired": "Rule name is required.",
        "keywordRequired": "Add at least one keyword.",
        "templateRequired": "Add a template reply.",
        "maxPerHourRange": "Max replies per hour must be 1..1000."
      },
      "upgradeTitle": "Auto-responses is a Pro feature",
      "upgradeDescription": "Reply automatically to comments and mentions based on keyword or sentiment rules. Available on Pro."
    },
    "reports": {
      "title": "Scheduled reports",
      "subtitle": "Email recurring analytics PDFs to your team or clients without anyone logging in.",
      "create": "Add schedule",
      "edit": "Edit schedule",
      "save": "Save schedule",
      "frequency": "Frequency",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "day": "Day",
      "dayOfMonth": "Day {{day}} of every month",
      "time": "Time (UTC)",
      "brand": "Brand",
      "allBrands": "All brands",
      "recipients": "Recipients",
      "recipientsHint": "Comma- or semicolon-separated email addresses.",
      "recipientCount_one": "{{count}} recipient",
      "recipientCount_other": "{{count}} recipients",
      "sendNow": "Send now",
      "lastSent": "Last sent {{date}}",
      "neverSent": "Never sent",
      "lastError": "Last error",
      "deleted": "Schedule deleted",
      "saved": "Schedule saved",
      "sent": "Report sent",
      "deleteConfirmTitle": "Delete this schedule?",
      "deleteConfirmMessage": "Recipients will stop receiving this report. You can recreate it later.",
      "empty": {
        "title": "No scheduled reports",
        "description": "Automatically email analytics PDFs to your team or clients."
      },
      "errors": {
        "noRecipients": "Add at least one recipient email."
      },
      "upgradeTitle": "Scheduled reports is a Pro feature",
      "upgradeDescription": "Email weekly or monthly analytics PDFs to your team and clients automatically. Available on Pro."
    },
    "profile": "Profile",
    "profileSubtitle": "Your personal account information",
    "name": "Name",
    "email": "Email",
    "emailAddress": "Email address",
    "avatar": "Profile photo",
    "saveProfile": "Save profile",
    "profileSaved": "Profile saved.",
    "profilePicture": "Profile picture",
    "profileManagedByGoogle": "Profile picture is managed by your Google account.",
    "avatarUploadComingSoon": "Avatar upload will land in a follow-up.",
    "signedInWith": "Signed in with",
    "accountInformation": "Account information",
    "displayName": "Display name",
    "yourName": "Your name",
    "verified": "Verified",
    "emailManagedByGoogle": "Email is managed by your Google account and can't be changed here.",
    "danger": "Danger zone",
    "deleteAccount": "Delete account",
    "deleteAccountWarning": "This action cannot be undone.",
    "inviteMember": "Invite member",
    "inviteByEmail": "Invite by email",
    "sendInvite": "Send invite",
    "pendingInvite": "Pending invite",
    "leaveWorkspace": "Leave workspace",
    "billing": "Billing",
    "currentPlan": "Current plan",
    "roleOwner": "Owner",
    "roleMember": "Member",
    "roleAdmin": "Admin",
    "roleApprover": "Approver",
    "appearance": "Appearance",
    "interfaceMode": "Interface mode",
    "interfaceModeDesc": "Choose your preferred color scheme.",
    "accentColor": "Accent color",
    "accentColorDesc": "Pick a color from the palette or paste a hex code. Saves automatically.",
    "flameColor": "Flame",
    "account": "Account",
    "accountDescription": "Profile settings, email preferences, and password management land here in the next iteration.",
    "namePlaceholder": "Your name",
    "emailLabel": "Email address",
    "emailEditableHint": "Email cannot be changed here. Contact support if you need to update it.",
    "emailSocialHint": "Managed by your {{provider}} account.",
    "changePassword": "Change password",
    "passwordCurrent": "Current password",
    "passwordNew": "New password",
    "passwordRules": "At least 8 characters and one number.",
    "passwordCurrentWrong": "Current password is incorrect.",
    "passwordTooWeak": "Password must be at least 8 characters and contain a number.",
    "passwordChangeFailed": "Failed to change password.",
    "passwordUpdated": "Password updated. Please sign in again.",
    "exportData": "Export your data",
    "exportDataDesc": "Get a JSON archive of your account and posts (GDPR).",
    "exportStarted": "Your data download is starting.",
    "exportFailed": "Export failed",
    "deleteAccountTitle": "Delete this account?",
    "deleteAccountConfirm": "Delete your account",
    "deleteAccountDesc": "Permanently delete your account after a 14-day grace period.",
    "deletionRequested": "Account deletion scheduled. Check your email for details.",
    "deletionFailed": "Couldn't request deletion — please try again.",
    "savedToast": "Saved.",
    "saveFailedToast": "Failed to save changes.",
    "light": "Light",
    "dark": "Dark",
    "lightMode": "Switch to light mode",
    "darkMode": "Switch to dark mode",
    "switchLanguage": "Switch language",
    "manageWorkspace": "Manage your account and workspace preferences.",
    "membership": "Membership",
    "memberSince": "Member since {{date}}",
    "managePlan": "Manage plan",
    "contactOwner": "Contact the workspace owner to manage the plan.",
    "connectedAppsDescription": "Third-party services and outgoing email.",
    "emailApp": "Email",
    "googleWorkspaceSMTP": "Google Workspace / SMTP",
    "smtpDescription": "Send team invitations and transactional mail from your own address instead of noreply@merkflow.eu.",
    "smtpFrom": "From",
    "smtpHost": "Host",
    "smtpConnected": "Connected",
    "connectEmail": "Connect email",
    "editEmail": "Edit email connection",
    "emailSubtitle": "Send team invitations + transactional mail from your own address.",
    "disconnectEmailConfirm": "Disconnect this email account? Future emails will use the default Merkflow sender.",
    "emailOwnerOnly": "Only workspace owners can configure email.",
    "googleAppPasswordTitle": "How to get a Google Workspace App Password",
    "step1": "Turn on 2-Step Verification at {{url}}",
    "step2": "Visit {{url}}",
    "step3": "Type a name like Merkflow and click Create",
    "step4": "Copy the 16-character password Google generates and paste it below",
    "passwordSecurity": "Merkflow stores the password encrypted at rest. We never log it and never send it back to your browser.",
    "yourEmail": "Your email address",
    "emailExample": "you@company.com",
    "appPassword": "App password",
    "keepCurrent": "(leave blank to keep current)",
    "passwordMask": "••••••••••••••••",
    "passwordPlaceholder": "xxxx xxxx xxxx xxxx",
    "passwordSpaces": "Spaces are fine — Google shows it as four groups of four characters.",
    "fromAddress": "From address",
    "fromAddressDefault": "Same as email by default",
    "fromName": "From name",
    "fromNameExample": "Acme Marketing",
    "advancedSmtp": "Advanced — SMTP host & port",
    "host": "Host",
    "port": "Port",
    "smtpDefaults": "Defaults: smtp.gmail.com:587 (STARTTLS). Override for Microsoft 365 (smtp.office365.com:587) or any other provider.",
    "testSuccess": "SMTP connection successful — credentials are valid.",
    "testFailed": "Connection failed.",
    "testConnection": "Test connection",
    "appPasswordRequired": "App password is required",
    "emailRequired": "Email address is required",
    "membersDescription": "Invite teammates and manage their access to this workspace.",
    "teamMembers": "Team members",
    "noMembers": "No members yet",
    "inviteFirstTeammate": "Invite your first teammate to start collaborating.",
    "removeConfirm": "Remove {{name}} from this workspace?",
    "noPendingInvitations": "No pending invitations",
    "pendingInviteDescription": "When you invite someone, their status will show up here until they accept.",
    "inviteExpires": "Expires {{date}}",
    "revokeInvitation": "Revoke invitation",
    "revokeConfirm": "Revoke the invitation for {{email}}?",
    "inviteTeammate": "Invite a teammate",
    "inviteSubtitle": "Send an invitation by email.",
    "emailPlaceholder": "teammate@company.com",
    "role": "Role",
    "memberDescription": "Can create + edit drafts and reply to engagement.",
    "approverDescription": "Member rights plus approve / reject posts.",
    "adminDescription": "Approver rights plus billing & connections.",
    "ownerPromotionNote": "Only existing owners can promote someone to OWNER, and only after they accept the invite.",
    "sendInvitation": "Send invitation",
    "planLimit": "You've hit your plan's team-member limit. Upgrade to invite more people.",
    "alreadyMember": "That person is already a member of this workspace.",
    "inviteFailed": "Invite failed (HTTP {{status}})",
    "privacy": "Privacy & data",
    "privacyDescription": "Your GDPR rights — export, retention, and account deletion",
    "deletionScheduled": "Account deletion scheduled",
    "deletionScheduledDesc": "Your account will be permanently deleted on {{date}}. Confirmation code: {{code}}",
    "cancelDeletion": "Cancel deletion request →",
    "exportDescription": "Download a complete JSON archive of your posts, brands, analytics, connections, and account information — your right under GDPR Article 20 (data portability).",
    "exportIncludes": "Includes: account info · workspaces · brands · posts · connected platforms · consent history",
    "exportExcludes": "Excludes: OAuth tokens, AI-generated visuals, reel videos (these expire and can be re-generated), and other people's activity on connected platforms (e.g. LinkedIn comments and likes from members — shown in-app only, never exported).",
    "preparingExport": "Preparing export…",
    "requestExport": "Request export",
    "dataRetention": "Data retention",
    "dataRetentionDescription": "How long Merkflow keeps your data.",
    "dataStorageNote": "Automated cleanup runs nightly. Data is stored on EU infrastructure (Hetzner, Germany).",
    "platformRetentionNote": "Content retrieved from connected platforms (LinkedIn, Meta, X) follows the shorter retention limits those platforms require. For example, LinkedIn members' comments and likes on your posts are removed within 48 hours; synced LinkedIn page posts within 6 months. We keep the reference IDs but not the content beyond these windows.",
    "deleteAccountDescription": "Permanently delete your account and all associated data. You have a 30-day grace period to cancel. After that, all your posts, brands, analytics, and connections are permanently removed.",
    "gdprArticle17": "This is your right under GDPR Article 17 (right to erasure).",
    "deletionScheduledFor": "Deletion scheduled for {{date}}",
    "deletionGracePeriod": "This starts a 30-day grace period",
    "deleteConfirmationText": "This will schedule your account for deletion in 30 days. All posts, brands, analytics, and connections will be permanently removed. You can cancel within the grace period.",
    "confirmDeleteAccount": "Yes, delete my account",
    "cancelDeletionRequest": "Cancel deletion request",
    "keepAccountActive": "Keep your account active",
    "cancelDeletionDescription": "This will cancel your deletion request and your account will remain active.",
    "confirmKeepAccount": "Yes, keep my account",
    "retention": {
      "postsLabel": "Posts & content",
      "postsPeriod": "24 months after creation",
      "analyticsLabel": "Analytics data",
      "analyticsPeriod": "12 months",
      "visualsLabel": "Visual media (images / reels)",
      "visualsPeriod": "90 days after post deletion",
      "engagementLabel": "Engagement history",
      "engagementPeriod": "12 months",
      "accountLabel": "Account data",
      "accountPeriod": "Until account deletion",
      "auditLabel": "Audit logs",
      "auditPeriod": "6 months",
      "backupsLabel": "Backups",
      "backupsPeriod": "Deleted within 30 days of account deletion"
    }
  },
  "aiVisibility": {
    "pageTitle": "AI Visibility",
    "pageSubtitle": "How {{name}} shows up in ChatGPT, Perplexity, and Google AI Overviews.",
    "pageSubtitleWorkspace": "How your brands show up in ChatGPT, Perplexity, and Google AI Overviews. Pick a brand to see the full report.",
    "pickBrand": "Pick a brand",
    "pickBrandHint": "Pick a brand above to see its full AI visibility report.",
    "noBrandsInWorkspace": "No brands in this workspace yet. Add one from the Brands page first.",
    "backToBrand": "Back to {{name}}",
    "runProbeNow": "Run probe now",
    "probeComplete": "Probe complete — fresh results below.",
    "probeStarted": "Probe started — running in the background. Results will appear below as they come in.",
    "probeRunning": "Probe running…",
    "probeAlreadyRunning": "A probe is already running for this brand — wait for it to finish.",
    "probeRateLimited": "Already probed in the last hour.",
    "downloadPdf": "Download PDF",
    "pdfGenerating": "Generating PDF…",
    "pdfReady": "PDF ready.",
    "pdfReadyBlocked": "PDF ready — if it didn't open, click here.",
    "pdfOpen": "Open PDF",
    "pdfDismiss": "Dismiss",
    "pdfFailed": "PDF generation failed — try again in a moment.",
    "pdfTimeout": "PDF still generating — check back in a minute.",
    "pdfRateLimited": "Daily PDF limit reached (3/day).",
    "pdfUpgradeNeeded": "Upgrade to Agency for PDF reports.",
    "probeFailed": "Probe failed — try again in a minute.",
    "probeUpgradeNeeded": "Upgrade to Pro to run probes.",
    "lastUpdated": "Updated {{date}}",
    "section1Title": "Score",
    "section2Title": "What to do next",
    "section3Title": "AI search probes",
    "section4Title": "WordPress + llms.txt",
    "section5Title": "Content gap analysis",
    "section6Title": "Learn",
    "outOf100": "out of 100",
    "radarTitle": "Score components",
    "radarMentions": "Mentions",
    "radarAiMentionRate": "AI mentions",
    "radarPostsPublished": "Posts",
    "radarPlatforms": "Platforms",
    "radarConsistency": "Consistency",
    "radarDiversity": "Diversity",
    "trendTitle": "90-day trend",
    "statMentions": "Mentions (30d)",
    "postsPublished": "Posts Published",
    "followers": "Followers",
    "postsPublishedTooltip": "Posts published across all platforms in the last 30 days. More posts = more brand signals for AI search engines.",
    "aiMentionRate": "AI mention rate",
    "noProbes": "No probes yet",
    "probeCount_one": "from {{count}} probe",
    "probeCount_other": "from {{count}} probes",
    "publishedPosts": "Published posts",
    "insufficientData": {
      "title": "Not enough data yet",
      "subtitle": "Publish a few more posts to start tracking your AI visibility — you have {{current}} so far."
    },
    "upgradeForProbes": "Upgrade to Pro to include AI search monitoring in your score.",
    "sentiment": {
      "positive": "Positively mentioned",
      "neutral": "Neutrally mentioned",
      "negative": "Negatively mentioned",
      "not_mentioned": "Not found"
    },
    "confidence": "confidence",
    "citations": {
      "title": "Citations",
      "empty": "No citations yet — runs after the next probe.",
      "brandCitedTitle": "Your URLs cited by AI engines (last 30 days)",
      "gap": "Citation gaps",
      "noGaps": "No competitor gaps detected — keep publishing to stay ahead.",
      "competitorsCited": "Competitors cited: {{domains}}",
      "generateBlog": "Generate blog post to close this gap →",
      "generating": "Generating draft…",
      "blogGenerated": "Citation-gap blog draft ready in your Blog tab.",
      "blogGenerateFailed": "Could not generate blog draft. Try again in a minute.",
      "verified": "Now cited by AI engines!"
    },
    "score": {
      "mentionRate": "Mention rate",
      "citationRate": "Citation rate",
      "engineCoverage": "Engine coverage",
      "sentiment": "Sentiment",
      "competitorDelta": "vs competitors",
      "v2Note": "Score v2 — based on actual AI engine mentions"
    },
    "engine": {
      "claude": "Claude",
      "perplexity": "Perplexity",
      "gemini": "Google AI"
    },
    "competitors": {
      "title": "Competitors",
      "add": "Add competitor",
      "limit": "{{count}}/{{max}} competitors",
      "remove": "Remove",
      "removeConfirm": "Remove this competitor? Probe history will be kept.",
      "shareOfVoice": "Share of voice (last 30 days)",
      "mentionRate": "{{pct}}% mentioned",
      "topCited": "Top cited sources",
      "sentimentBreakdown": "Sentiment breakdown",
      "upgrade": "Compare your brand with competitors. Available on Pro.",
      "youLabel": "You",
      "duplicate": "Competitor with this name is already active for this brand.",
      "nameLabel": "Competitor name",
      "namePlaceholder": "e.g. Competitor Co.",
      "urlLabel": "Website (optional)",
      "empty": "No probe data yet — runs every Monday or hit \"Probe now\"."
    },
    "claudeMonthlyNote": "Claude probes run monthly (last: {{date}}). Use \"Probe now\" to check all engines.",
    "recs": {
      "lowMentionCount": {
        "title": "Publishing cadence is low",
        "body": "You've published {{count}} posts in the last 30 days. AI search engines associate brands with what shows up often and recently — consistency beats batches.",
        "action": "Open cadence"
      },
      "narrowPlatformSpread": {
        "title": "Narrow platform spread",
        "body": "You're connected to {{count}} platforms. Spreading publishing across LinkedIn, Instagram, and a third channel is what makes AI engines see you as a multi-surface brand.",
        "action": "Connect another platform"
      },
      "lowConsistency": {
        "title": "Posting in bursts, not weekly",
        "body": "Consistency is at {{pct}}%. Weekly rhythm beats big-batch bursts — AI models pick up on recency + recurrence.",
        "action": "Review cadence"
      },
      "lowDiversity": {
        "title": "Content mix too narrow",
        "body": "Content-type diversity is at {{pct}}%. Mixing educational, social-proof, and thought-leadership posts teaches AI what you're about — not just how often you post.",
        "action": "Plan a mix"
      },
      "categoryProbeMiss": {
        "title": "AI search doesn't associate you with your category",
        "body": "{{count}} of {{total}} category queries didn't mention you. Add a blog post that defines the category you play in and where you fit.",
        "action": "Generate blog draft"
      },
      "liveWebOnly": {
        "title": "You show up in live web search, not yet in AI training data",
        "body": "Perplexity and Gemini find you {{count}}× across their live-web probes, but Claude doesn't yet. That typically catches up within ~6 months as content propagates — keep publishing."
      },
      "noWordpressConnection": {
        "title": "Blog posts go nowhere without WordPress",
        "body": "We can only publish blog drafts + llms.txt if a WordPress site is connected. Two minutes with an Application Password and you're done.",
        "action": "Connect WordPress"
      },
      "noRecentBlogDrafts": {
        "title": "No blog drafts generated in 30 days",
        "body": "The weekly blog job may be paused or the plan cap is hit. Worth a look — a single well-indexed post a week compounds for AI visibility.",
        "action": "Open blog"
      },
      "staleLlmsTxt": {
        "title": "Refresh your llms.txt",
        "body": "Your llms.txt hasn't been refreshed in over {{days}} days. A fresh push tells AI crawlers you're active.",
        "action": "Re-publish llms.txt"
      }
    },
    "statPlatforms": "Platforms",
    "statConsistency": "Consistency",
    "statDiversity": "Diversity",
    "noScoreYet": "Come back after your first week — we need a bit of posting history to score you.",
    "allGoodTitle": "Strong AI visibility",
    "allGoodBody": "No urgent actions. Keep posting weekly to maintain.",
    "probeTab_overview": "Overview",
    "probeTab_byEngine": "By engine",
    "probeTab_queries": "Queries",
    "noProbesYet": "No probe results yet. Run one now or wait for Monday's scheduled run.",
    "qt_direct": "Direct",
    "qt_category": "Category",
    "qt_problem": "Problem",
    "qt_custom": "Custom",
    "probeMentioned": "Mentioned",
    "probeNotMentioned": "Not mentioned",
    "viewResponse": "View response",
    "enginePassRate": "{{pct}}% — {{mentions}} of {{probes}} probes mentioned you",
    "engineNegatives": "{{count}} negative/uncertain mentions",
    "queriesDefaultsTitle": "Default queries",
    "queriesRegenerate": "Regenerate all",
    "regenCounter": "{{count}} / {{limit}} today",
    "regenDailyLimit": "Daily limit reached — try again tomorrow",
    "queriesCustomTitle": "Custom queries",
    "queriesCustomEmpty": "No custom queries. Add one on the brand detail page.",
    "wpNotConnectedTitle": "Connect WordPress to publish blog posts",
    "wpNotConnectedBody": "Without a WordPress site, blog drafts stay hidden and llms.txt can't be published. Two minutes with an Application Password.",
    "wpGoConnect": "Connect WordPress",
    "wpConnectedTitle": "WordPress connected",
    "wpLastVerified": "Last verified {{date}}",
    "wpRepublish": "Re-publish llms.txt",
    "wpRepublishSuccess": "Published — {{bytes}} bytes pushed to your site.",
    "wpRepublishFailed": "Re-publish failed",
    "wpRepublishNeedsPlugin": "llms.txt requires the Merkflow plugin",
    "wpRepublishNeedsPluginHint": "llms.txt re-publish only works when this brand is connected via the Merkflow plugin. Disconnect and reconnect using the Plugin option to enable it.",
    "wpApiKeyLlmsHint": "llms.txt requires the Merkflow plugin. Disconnect and reconnect via plugin to enable it.",
    "wpPluginLlmsUrl": "Served at",
    "wpRecentDrafts": "Recent blog drafts",
    "wpNoDrafts": "No drafts yet — the weekly job runs Mondays 07:00.",
    "wpManageAll": "Manage all drafts",
    "section5Hint": "Posts per content type in the last 30 days — dashed line is the suggested minimum.",
    "ctCount": "{{count}} / min {{min}}",
    "ctGenerateOfType": "Generate a {{type}} post",
    "ct_EDUCATIONAL": "Educational",
    "ct_SOCIAL_PROOF": "Social proof",
    "ct_THOUGHT_LEADERSHIP": "Thought leadership",
    "ct_PRODUCT_HIGHLIGHT": "Product highlight",
    "ct_INDUSTRY_REACTION": "Industry reaction",
    "ct_BEHIND_THE_SCENES": "Behind the scenes",
    "learnQ1": "What is a GEO Score?",
    "learnA1": "A 0–100 score that measures how consistently your brand shows up across social platforms. AI search engines learn who matters in a category by seeing mentions across the web. The more often and more consistently you publish, the more they associate you with your space.",
    "learnQ2": "What's the probe doing?",
    "learnA2": "Every Monday, Merkflow sends 3 questions about your category to Claude, Perplexity, and Gemini — without your brand name in the question. We check whether any of them mention you in the answer. That's a direct signal of whether AI search knows who you are.",
    "learnQ3": "How do I improve my score?",
    "learnA3": "Publish consistently (weekly beats batches), spread across platforms (LinkedIn + Instagram minimum), cover a range of content types (thought leadership + educational carry extra weight), and publish to a blog with a public llms.txt so AI crawlers can index you directly.",
    "learnQ4": "What's llms.txt?",
    "learnA4": "A plain-text file at the root of your website that tells AI crawlers who you are and what you're about — the AI-era equivalent of robots.txt. Merkflow generates and publishes yours automatically if you connect WordPress.",
    "citability": {
      "title": "GEO Score",
      "good": "GEO ✓",
      "improvable": "GEO ↑",
      "low": "GEO ↓",
      "rescore": "Rescore",
      "brandClarity": "Brand clarity",
      "factualDensity": "Factual density",
      "keywordRelevance": "Keyword relevance",
      "answerPotential": "Answer potential",
      "entityReinforcement": "Entity reinforcement",
      "suggestions": "Suggestions",
      "improve": "Improve with AI",
      "improving": "Rewriting…",
      "improveHint": "Re-runs the AI with these suggestions as constraints. Costs roughly €0.02–0.03 per click depending on your plan's model.",
      "improveError": "Improve failed. The post may already be published or you've hit the 5/hour cap (shared with rescore)."
    },
    "correlation": {
      "title": "Publishing impact",
      "period": "Last {{days}} days",
      "postsAxis": "Posts published",
      "scoreAxis": "GEO Score",
      "positiveCorrelation": "Weeks with {{count}}+ posts had {{pct}}% higher AI mention rates.",
      "contentTypeSignal": "Your '{{type}}' posts correlate with the strongest probe improvements.",
      "platformSignal": "{{platform}} posts contribute most to your AI visibility — AI engines cite this network frequently.",
      "consistencySignal": "Consistent weekly publishing has improved your GEO score.",
      "inactivityWarning": "No posts for {{weeks}} weeks — your GEO score dropped {{delta}} points."
    },
    "gapPost": {
      "generate": "Generate post to fix this",
      "generating": "Generating…",
      "success": "Draft created — review it in your inbox",
      "failed": "Couldn't generate the post — try again in a minute.",
      "alreadyMentioned": "Probe already mentions the brand — no gap to fix."
    },
    "naming": {
      "title": "Brand naming consistency",
      "consistent": "{{pct}}% of your posts use your exact brand name.",
      "tip": "Use \"{{name}}\" consistently in every post. AI search engines treat name variations as different entities."
    },
    "customProbeRunNow": "Run this probe now",
    "customProbeRan": "Probe ran — fresh result below.",
    "customProbeRunFailed": "Couldn't run the probe — try again in a minute.",
    "customProbeRateLimit": "Rate-limited — try again in a few minutes.",
    "customProbeRemoved": "Custom probe removed.",
    "customProbeRemoveFailed": "Couldn't remove the probe — try again.",
    "customProbeRemoveConfirm": "Remove this custom probe? Past results stay in your history.",
    "customProbeAdded": "Custom probe added — runs in the next cycle.",
    "customProbeAddFailed": "Couldn't add the probe — try again.",
    "customProbeAdd": "Add probe",
    "customProbePlaceholder": "Type a question to ask AI engines (8–200 chars)…",
    "doubleClickToEdit": "Double-click to edit",
    "keywords": {
      "title": "Topic coverage",
      "reinforced": "Reinforced",
      "gaps": "Gaps",
      "untested": "Untested",
      "addProbe": "Add as probe query",
      "minPosts": "Publish more posts to see topic coverage ({{count}} / {{min}} scored).",
      "probeAdded": "Custom probe added — runs in the next probe cycle.",
      "probeAddFailed": "Couldn't add the probe — please try again."
    }
  },
  "brands": {
    "title": "Brands",
    "subtitle": "Every brand you manage across your workspace.",
    "addBrand": "New brand",
    "carouselTemplate": {
      "title": "Carousel template",
      "subtitle": "Pick the look for every LinkedIn carousel this brand publishes. Switch any time.",
      "systemBadge": "Default",
      "create": "Create template",
      "createSubtitle": "Custom-design your own",
      "proGate": "Custom designs on Pro",
      "proGateSubtitle": "Upgrade to Pro to build your own templates.",
      "brandColor": "Brand accent color",
      "brandColorHint": "Overrides the template's default accent. Leave blank to use the template default."
    },
    "competitors": {
      "title": "Competitors",
      "add": "Add",
      "remove": "Remove",
      "empty": "No competitors added yet.",
      "counter": "{{count}}/{{max}} competitors",
      "upgrade": "Compare AI visibility with competitors. Available on Pro."
    },
    "noBrands": "No brands yet. Add your first brand.",
    "brandName": "Brand name",
    "website": "Website",
    "description": "Description",
    "postsThisMonth": "Posts this month",
    "postsTotal": "posts total",
    "noPostsYet": "No posts yet",
    "crawlWebsite": "Crawl website",
    "reCrawl": "Re-crawl",
    "crawlNow": "Crawl now",
    "crawling": "Crawling...",
    "crawlComplete": "Crawl complete",
    "crawlFailed": "Crawl failed",
    "notYetCrawled": "Not yet crawled",
    "websiteNotAnalyzed": "Website not yet analyzed.",
    "whatYouToldUs": "What you told us",
    "whatWeLearned": "What we learned",
    "setupProfile": "Set up brand profile",
    "noProfile": "No brand profile yet.",
    "whatYouDo": "What you do",
    "idealCustomer": "Ideal customer",
    "tone": "Tone",
    "postVoice": "Post voice",
    "language": "Language",
    "deleteBrand": "Delete brand",
    "deleteConfirmTitle": "Delete {{name}}?",
    "deleteConfirmMessage": "Every post, analytics row, GEO score, blog draft, and engagement item for this brand will be permanently removed. This cannot be undone.",
    "addBrandBtn": "Add brand",
    "emptyTitle": "Add a brand and Merkflow learns what it does.",
    "emptyDescription": "Drop in the URL, answer a few questions, and Merkflow handles the rest.",
    "placeholderName": "My brand",
    "placeholderWebsite": "https://example.com",
    "placeholderDescription": "What does this brand do?",
    "identityTitle": "Brand identity",
    "logoDark": "Dark logo",
    "logoLight": "Light logo",
    "logoDarkHint": "For light backgrounds",
    "logoLightHint": "For dark backgrounds + reels",
    "uploadLogo": "Upload {{variant}}",
    "deleteConfirm": "Delete brand \"{{name}}\"? This will also delete all its posts.",
    "noWebsite": "No website",
    "crawledTime": "Crawled {{time}}",
    "notFound": "Brand not found",
    "notFoundDescription": "This brand may have just been deleted, or the link points to a different workspace.",
    "postsTitle": "Brand posts",
    "postsSubtitle": "Every post published or scheduled for this brand.",
    "showRemoved": "Show removed",
    "tellUsAbout": "Tell us about {{brandName}}",
    "onboardingHint": "Help the AI understand your brand. All fields are optional.",
    "whatYouDoExample": "We build sustainable packaging for e-commerce brands",
    "idealCustomerExample": "DTC brands doing 1M+ revenue looking to go green",
    "recentWins": "Recent wins or projects",
    "winPlaceholder": "Win or project #{{index}}",
    "backToBrands": "Back to brands",
    "totalReach": "Total reach",
    "engagements": "Engagements",
    "pendingReview": "Pending review",
    "voiceFounderWithName": "Founder — {{name}}",
    "voiceFounderPersonal": "personal",
    "voiceBrandShort": "Brand",
    "languageDutchFlag": "🇳🇱 Nederlands",
    "languageEnglishFlag": "🇬🇧 English",
    "languageBothFlag": "🌐 Both",
    "updatedTime": "Updated {{time}}",
    "targetAudience": "Target audience",
    "valueProposition": "Value proposition",
    "brandVoice": "Brand voice",
    "productsServices": "Products / services",
    "keyMessages": "Key messages",
    "socialProof": "Social proof",
    "recentPosts": "Recent posts",
    "viewAllArrow": "View all →",
    "noPostsDescription": "Generate your first batch of AI posts for this brand.",
    "learnedFromPosts": "What we learned from your posts",
    "requiresApproval": {
      "label": "Require approval before publishing",
      "description": "Generated posts wait in PENDING review and trigger an approval-notification email. Off by default — drafts auto-approve so they go straight into the schedule."
    },
    "voiceMaturity": {
      "title": "Brand voice",
      "subtitle": "How well Merkflow knows your voice",
      "postDepth": "Post depth",
      "themes": "Themes learned",
      "style": "Style learned",
      "topics": "Topic breadth",
      "quality": "Content quality",
      "publishMore_one": "Publish {{count}} more post to strengthen your voice profile.",
      "publishMore_other": "Publish {{count}} more posts to strengthen your voice profile.",
      "fullyLearned": "Merkflow has a strong understanding of your voice.",
      "insufficient_one": "Publish {{count}} more post to start learning your voice. You have {{current}} so far.",
      "insufficient_other": "Publish {{count}} more posts to start learning your voice. You have {{current}} so far."
    },
    "noPostMemory": "No post memory yet. Once a brand has a few published posts, Merkflow summarizes the recurring themes and tone here.",
    "postsAnalysed_one": "{{count}} post analysed",
    "postsAnalysed_other": "{{count}} posts analysed",
    "recurringThemes": "Recurring themes",
    "howPostsSound": "How your posts sound",
    "topTopics": "Top topics",
    "aiCadence": "AI cadence",
    "editArrow": "Edit →",
    "noCadenceConfigured": "No cadence configured",
    "onTrack": "On track",
    "needsAttention": "Needs attention",
    "cadenceSummary_one": "{{posts}} posts / week across {{count}} platform",
    "cadenceSummary_other": "{{posts}} posts / week across {{count}} platforms",
    "noPlatformsScheduled": "No platforms scheduled",
    "cadenceRow": "{{count}}× / week · {{time}}",
    "defaultPostingAccounts": "Default posting accounts",
    "defaultPostingHint": "Posts generated for this brand will publish from these accounts by default. You can change the account per post in the review inbox.",
    "noSocialAccountsYet": "No social accounts connected yet.",
    "connectAccountArrow": "Connect an account →",
    "defaultAccountFor": "Default account for {{platform}}",
    "notSet": "Not set",
    "tonePreset_professional": "Professional",
    "tonePreset_playful": "Playful",
    "tonePreset_direct": "Direct",
    "tonePreset_technical": "Technical",
    "tonePreset_inspiring": "Inspiring",
    "tonePreset_no_corporate_fluff": "No corporate fluff",
    "tonePreset_data_driven": "Data-driven",
    "tonePreset_conversational": "Conversational",
    "tonePreset_bold": "Bold",
    "languageNameDutch": "Nederlands",
    "languageNameEnglish": "English",
    "languageNameBoth": "Both",
    "nameRequired": "Name is required",
    "mustBeValidUrl": "Must be a valid URL",
    "voiceBrand": "As brand (we)",
    "voiceFounder": "As founder (I / me)",
    "founderNamePlaceholder": "Founder name (used when signing off posts)",
    "founderVoiceNote": "Founder voice gets 5× more LinkedIn reach than brand voice.",
    "extraContext": "Anything else the AI should know?",
    "extraContextExample": "Never mention competitor X, always end with a question",
    "saveAndCrawl": "Save and crawl",
    "aiVisibility": "AI Visibility",
    "aiVisibilityOverviewTitle": "AI Visibility overview",
    "aiVisibilityOverviewSubtitle": "How your brand shows up in AI search engines.",
    "seeFullReport": "See full report",
    "topRecommendations": "Top recommendations",
    "aiVisibilityAllGood": "Strong AI visibility. Keep cadence steady.",
    "aiVisibilityScore": "AI Visibility Score",
    "aiVisibilityEmpty": "Not enough data yet. Publish at least 3 posts to see your brand's AI search visibility score. The score updates nightly.",
    "aiVisibilityTooltip": "{{score}}/100 — {{mentions}} mentions across {{platforms}} platforms ({{days}}d)",
    "mentions": "Brand mentions",
    "platformSpread": "Platform spread",
    "platformsActive": "platforms active",
    "consistency": "Consistency",
    "weeksActive": "weeks with posts",
    "scoreTrend": "Score trend — last 90 days",
    "probeDetails": "Probe details",
    "probeExplain": "We probe AI engines with these questions to see if your brand appears in their answers.",
    "queriesTested": "Queries tested",
    "lastProbed": "last probed {{date}}",
    "positiveMentions": "Positive mentions",
    "aiRecommends": "AI recommends your brand",
    "negativeMentions": "Negative mentions",
    "aiUnsure": "AI knows you but says \"not sure\"",
    "notMentioned": "Brand not mentioned at all",
    "improvementTips": "How to improve your score",
    "tipMorePosts": "Publish more posts — aim for 20+ per month ({{current}}/20 this period)",
    "tipMorePlatforms": "Connect more platforms — posting on {{current}}/4 active platforms",
    "tipConsistentCadence": "Keep your cadence consistent — approve posts every week, not in batches",
    "tipMixContent": "Mix content types — thought leadership and educational posts carry extra weight",
    "successMessage": "Strong AI visibility — your brand is consistently showing up across platforms",
    "probeSettings": "AI Probe Settings",
    "probeSettingsHint": "Controls how Perplexity searches for your brand",
    "country": "Country",
    "autoDetect": "Auto-detect",
    "searchLanguage": "Search language",
    "searchRecency": "Search recency",
    "recencyDefault": "Default (month)",
    "recencyDay": "Last 24 hours",
    "recencyWeek": "Last week",
    "recencyMonth": "Last month",
    "recencyYear": "Last year",
    "probeAllTypes": "All types",
    "probeDirect": "Brand search",
    "probeCategory": "Category search",
    "probeProblem": "Problem search",
    "probeCustom": "Custom",
    "probeAnyResult": "Any result",
    "probePositive": "Positive",
    "probeNegative": "Negative",
    "probeNotFoundOpt": "Not found",
    "probeAllEngines": "All engines",
    "probeSearchPlaceholder": "Search query text or AI response…",
    "probeClear": "Clear",
    "probeResultCount_one": "{{filtered}} of {{total}} result",
    "probeResultCount_other": "{{filtered}} of {{total}} results",
    "probeNoMatches": "No probe results match the current filters.",
    "probePage": "Page {{current}} of {{total}}",
    "probePrev": "Previous page",
    "probeNext": "Next page",
    "engineClaudeFull": "Claude AI (training data)",
    "enginePerplexityFull": "Perplexity (live web)",
    "viaEngine": "via {{engine}}",
    "probeNegativeBadge": "Negative mention",
    "probeExcerpt": "AI response excerpt",
    "probeFullAnswer": "Show full answer",
    "defaultProbesTitle": "Default probes",
    "defaultProbesHint": "Auto-generated from your brand profile: a direct name search, a category question, and a problem-focused question. Toggle off to skip a type on the next run; regenerate to refresh the wording.",
    "defaultProbesRegenerate": "Regenerate",
    "defaultProbesEmpty": "No default probes yet — the next scheduled run will generate them.",
    "probeNegativeExcerpt": "AI mentioned you negatively",
    "tipDirectNotFound": "Claude doesn't know your brand by name yet. Increase online presence and content volume.",
    "tipCategoryNotFound": "Your brand wasn't listed among category leaders. Publish more thought leadership content.",
    "tipCustomNotFound": "Not mentioned for this query. Keep publishing relevant content.",
    "tipProblemNotFound": "Your brand didn't come up as a solution. Create content that directly addresses this problem.",
    "customProbes": "Custom probes",
    "customProbesHint": "Add your own questions to test what AI engines say about your brand. These run alongside the auto-generated probes every Monday.",
    "runProbeTitle": "Run this probe now",
    "deleteProbeTitle": "Delete probe",
    "customProbePlaceholder": "e.g. What are the best social media management tools?",
    "crawlSocialProfile": "Social profile",
    "crawlNeedsConnectionBadge": "Connect account",
    "crawlSkippedSocial": "This looks like a social profile, not a website. We'll build your brand profile from your own posts instead.",
    "crawlNeedsConnection": "Connect a social account and we'll learn your voice and topics from your real posts.",
    "crawlLearningBadge": "Learning from posts",
    "crawlLearning": "Your account is connected — we'll learn your voice and topics from your real posts on the next sync."
  },
  "carouselTemplatesPage": {
    "title": "Carousel templates",
    "subtitle": "Design how your LinkedIn carousels look. Templates are assigned per brand.",
    "assignments": "Brand assignments",
    "colBrand": "Brand",
    "colTemplate": "Template",
    "colAccent": "Accent color",
    "useDefault": "Default ({{name}})",
    "accentPlaceholder": "#e8540a",
    "noBrands": "No brands in this workspace yet.",
    "assignmentSaved": "Saved",
    "assignmentSaveFailed": "Could not save assignment",
    "yourTemplates": "Your templates",
    "systemTemplates": "System templates",
    "systemSubtitle": "Three battle-tested designs you can use as-is or duplicate to customize.",
    "systemBadge": "System",
    "createNew": "Create new",
    "duplicate": "Duplicate",
    "noCustom": "No custom templates yet. Duplicate a system template below or click \"Create new\" to start from scratch.",
    "copyName": "Template copy",
    "duplicateFailed": "Could not duplicate template",
    "deleteTitle": "Delete template",
    "deleteConfirm": "Delete \"{{name}}\"? Brands using it will fall back to the default.",
    "deleted": "Template deleted",
    "deleteFailed": "Could not delete template"
  },
  "carouselDesigner": {
    "untitledName": "Untitled template",
    "createFailed": "Could not create template",
    "saved": "Template saved",
    "saveFailed": "Save failed",
    "previewFailed": "Preview failed",
    "proGate": "Pro / Agency only",
    "proGateSubtitle": "The Carousel Design Studio is available on Pro and Agency. Upgrade to design custom templates.",
    "ownerGate": "Workspace owners only",
    "ownerGateSubtitle": "Only the workspace owner can design or edit carousel templates. Ask your workspace owner to make changes, or request owner access.",
    "downloadPdf": "Download PDF",
    "startFromScratch": "Start from scratch",
    "startFromScratchHint": "Pick a theme and we handle the typography, spacing, and hierarchy for you.",
    "section": {
      "theme": "Theme",
      "fonts": "Typography",
      "color": "Accent color",
      "background": "Background"
    },
    "bg": {
      "light": "Light",
      "dark": "Dark"
    },
    "slot": {
      "title": "Title",
      "titleHint": "{{TITLE}} is replaced with the post topic at generation time.",
      "subtitle": "Subtitle",
      "badge": "Badge",
      "headline": "Headline",
      "body": "Body",
      "cta": "Button text",
      "footer": "Footer",
      "placeholderHint": "Tokens like {{TITLE}}, {{BODY}}, {{CTA_TEXT}} are replaced by the AI when generating a real post. Use them so this template adapts to every piece of content."
    },
    "chooseStart": "Choose a starting point",
    "chooseStartSubtitle": "Start from one of the system templates or duplicate one you already saved.",
    "preview": "Preview",
    "elements": "Elements",
    "slideType": "Slide type",
    "noSelection": "Click an element to edit its properties.",
    "position": "Position",
    "element": {
      "text": "Text",
      "shape": "Shape",
      "logo": "Logo",
      "divider": "Divider",
      "swipe": "Swipe",
      "counter": "Counter",
      "button": "Button"
    },
    "slide": {
      "cover": "Cover",
      "content": "Content",
      "cta": "CTA"
    },
    "field": {
      "x": "x",
      "y": "y",
      "width": "width",
      "height": "height",
      "fontSize": "font size",
      "fontWeight": "font weight",
      "color": "color",
      "align": "align",
      "shapeType": "type",
      "fill": "fill",
      "borderRadius": "border radius",
      "opacityPct": "opacity %",
      "variant": "variant",
      "maxWidth": "max width",
      "maxHeight": "max height",
      "direction": "direction",
      "thickness": "thickness",
      "bgColor": "background",
      "textColor": "text color"
    },
    "align": {
      "left": "left",
      "center": "center",
      "right": "right"
    },
    "shape": {
      "rect": "rectangle",
      "circle": "circle",
      "line": "line"
    },
    "variant": {
      "dark": "dark (for light backgrounds)",
      "light": "light (for dark backgrounds)"
    },
    "direction": {
      "horizontal": "horizontal",
      "vertical": "vertical"
    }
  },
  "review": {
    "title": "Review",
    "subtitle": "Manage drafts, approvals, and scheduled posts across all platforms",
    "approve": "Approve",
    "reject": "Reject",
    "edit": "Edit",
    "noPostsPending": "No posts pending review.",
    "noPendingPosts": "No posts pending review.",
    "emptyDescription": "Posts will appear here once they're generated. Set up a content cadence for your brands to get weekly AI-generated posts.",
    "scheduledFor": "Scheduled for {{date}}",
    "generateMore": "Generate more",
    "editPost": "Edit post",
    "characters": "characters",
    "postPreview": "Post preview",
    "pendingReview": "Pending review",
    "tabOverview": "overview",
    "tabCalendar": "calendar",
    "tabAnalytics": "analytics",
    "contentCalendar": "Content Calendar",
    "allPosts": "All posts",
    "allBrands": "All brands",
    "allPlatforms": "All platforms",
    "standaloneOnly": "Standalone only",
    "clearFilter": "Clear filter",
    "sortNewest": "Newest first",
    "sortOldest": "Oldest first",
    "deleteAll": "Delete all",
    "deleteAllConfirm_one": "Delete {{count}} post? This only removes it from Merkflow and can't be undone.",
    "deleteAllConfirm_other": "Delete all {{count}} posts? This only removes them from Merkflow and can't be undone.",
    "deleteAllDone_one": "{{count}} post deleted",
    "deleteAllDone_other": "{{count}} posts deleted",
    "deleteAllFailed": "Some posts couldn't be deleted",
    "scheduleNewPost": "Schedule new post",
    "recentActivity": "Recent activity",
    "latestEngagement": "Latest engagement",
    "noNewActivity": "No new activity",
    "commentsAndMentions": "Comments and mentions appear here"
  },
  "posts": {
    "title": "Posts",
    "subtitle": "Every post across your workspace. Filter by brand, platform, or status.",
    "generate": "Generate posts",
    "generateOne": "Generate post",
    "deleteConfirmPlatform": "Deleting this post will also remove it from {{platform}}. Continue?",
    "deleteConfirmLocal": "Delete this post? This only removes it from Merkflow.",
    "deleteConfirmInstagram": "Deleting here removes the post from Merkflow. Instagram doesn't allow programmatic deletion — remove it from the Instagram app manually. Continue?",
    "deleteConfirmSyncedIn": "This post was published directly on {{platform}} and synced into Merkflow. Deleting here only removes it from Merkflow — the original stays on {{platform}} until you remove it there. Continue?",
    "generateSubtitle": "AI writes platform-optimized drafts that land in your review inbox",
    "writePost": "Write post",
    "writePostSubtitle": "Manual post — bypasses the AI queue and lands as APPROVED",
    "approveAll": "Approve all",
    "approveAllPending_one": "Approve {{count}} pending post",
    "approveAllPending_other": "Approve all {{count}} pending posts",
    "approveAllConfirm_one": "Approve {{count}} pending post? They'll be scheduled to publish.",
    "approveAllConfirm_other": "Approve all {{count}} pending posts? They'll be scheduled to publish.",
    "approveAllDone_one": "{{count}} post approved",
    "approveAllDone_other": "{{count}} posts approved",
    "import": {
      "button": "Import CSV",
      "dropzone": "Drop your CSV file here",
      "dropzoneHint": "Columns: platform, content, scheduled_at, brand_id, hashtags",
      "browse": "Browse files",
      "downloadTemplate": "Download template CSV",
      "summary": "{{valid}} valid, {{invalid}} invalid out of {{total}} rows",
      "errorsFound": "Some rows have errors and will be skipped:",
      "platform": "Platform",
      "content": "Content",
      "scheduledAt": "Scheduled",
      "brand": "Brand",
      "status": "Status",
      "confirm_one": "Import {{count}} post",
      "confirm_other": "Import {{count}} posts",
      "importing": "Importing…",
      "success_one": "{{count}} post imported successfully",
      "success_other": "{{count}} posts imported successfully",
      "fileTooLarge": "File too large (max 1MB)",
      "tooManyRows": "Too many rows (max 200)",
      "invalidFormat": "Invalid CSV format",
      "processing": "Importing posts in the background…",
      "canCloseHint": "You can close this window — the import keeps running.",
      "closeAndKeepRunning": "Close (import keeps running)",
      "failed": "Import failed",
      "planLimitFailed_one": "{{count}} row hit your monthly post limit and was skipped. Buy a top-up or wait for month rollover.",
      "planLimitFailed_other": "{{count}} rows hit your monthly post limit and were skipped. Buy a top-up or wait for month rollover.",
      "otherFailed_one": "{{count}} row failed to save (see logs for detail).",
      "otherFailed_other": "{{count}} rows failed to save (see logs for detail)."
    },
    "published": "Published",
    "draft": "Draft",
    "scheduled": "Scheduled",
    "failed": "Failed",
    "pending": "Pending",
    "reelFailed": "Reel generation failed",
    "retryReel": "Try again",
    "reelGenerating": "Generating reel…",
    "reelBadge": "REEL",
    "carouselBadge": "CAROUSEL",
    "linkedinTextPost": "LinkedIn text post",
    "carouselSlideLabel": "Slide",
    "carouselPrev": "Previous slide",
    "carouselNext": "Next slide",
    "storyBadge": "STORY",
    "storyExpired": "Expired",
    "storyArchived": "Archived in Merkflow",
    "mediaFormat": {
      "all": "All",
      "feed": "Feed",
      "reel": "Reel",
      "story": "Story",
      "carousel": "Carousel"
    },
    "sortOrder": {
      "label": "Sort order",
      "newest": "Newest first",
      "oldest": "Oldest first"
    },
    "hashtagsLabel": "Hashtags ({{count}})",
    "seedLabel": "seed",
    "traceInputs": "in:",
    "traceOutputs": "out:",
    "retrySuccess": "Re-queued for publishing — should go out within a minute.",
    "retryFailed": "Retry failed — try again or check the connection.",
    "manualPublish": {
      "title": "Manual publish required",
      "companyPageReason": "LinkedIn company-page posting requires the Community Management API. Open LinkedIn and post manually for now.",
      "failedReason": {
        "manual_only_no_oauth": "Connection is manual-only (no OAuth token). Open LinkedIn and post from the {{accountName}} page directly.",
        "linkedin_manual_mode": "LinkedIn is in manual publish mode — automated publishing is disabled. Copy the content and post it from LinkedIn directly.",
        "linkedin_company_share_api": "LinkedIn company-page posting requires the Community Management API. Approve manually, or switch this brand to a personal-profile connection.",
        "linkedin_carousel_share_api": "LinkedIn document carousels require the Community Management API. Post as text + image, or approve manually after the LinkedIn upgrade.",
        "linkedin_personal_no_account_id": "Personal LinkedIn connection is missing its account identifier — reconnect to enable Share-API publishing.",
        "linkedin_unknown_mode": "Unknown LinkedIn publish mode '{{mode}}'. An admin must reset the setting."
      },
      "openLinkedIn": "Open in LinkedIn",
      "copyText": "Copy text",
      "copiedShort": "Copied",
      "copiedToast": "Post text copied to your clipboard.",
      "copyFailed": "Copy failed — select the text manually.",
      "confirmPublished": "I published it",
      "confirmedToast": "Post marked as published.",
      "confirmFailed": "Could not confirm — refresh and try again.",
      "downloadPdf": "Download carousel PDF",
      "downloadImage": "Download image",
      "downloadVideo": "Download video",
      "attachHint": "After opening LinkedIn, click + (Document/Photo/Video) in the compose box to attach the downloaded file.",
      "pasteHint": "Text is on your clipboard. Paste with ⌘V (or Ctrl+V) into LinkedIn's compose box.",
      "companyAdminHint": "Opening the {{name}} page admin with the compose dialog ready. If the admin URL doesn't open the compose automatically, click \"Start a post\" — you'll already be posting as the company.",
      "companyPublicHint": "Opening the {{name}} company page. Click \"Admin tools\" → \"Create a post\" to compose as the company. Paste the text from your clipboard."
    },
    "republishSuccess": "Republishing — fresh copy goes out within a minute.",
    "republishFailed": "Republish failed — try again or check the connection.",
    "noPosts": "No posts yet.",
    "deletePost": "Delete post",
    "deletePostConfirm": "Are you sure you want to delete this post?",
    "allPlatforms": "All platforms",
    "allBrands": "All brands",
    "allStatuses": "All statuses",
    "viewOnPlatform": "View on {{platform}}",
    "gridView": "Grid view",
    "tableView": "Table view",
    "emptyDescription": "Merkflow generates your first posts on Monday. You can also write manual posts via the review inbox.",
    "showPending": "Show pending",
    "showRejected": "Show rejected",
    "showFailed": "Show failed",
    "postsCount_one": "{{count}} post",
    "postsCount_other": "{{count}} posts",
    "pageOf": "Page {{current}} of {{total}}",
    "removedFromPlatform": "Removed from platform",
    "aboutBrand": "About",
    "selectBrand": "Select a brand…",
    "ownBrand": "{{name}} (own brand)",
    "crossBrandVoice": "Post will use {{brandName}}'s voice to talk about {{otherBrandName}}",
    "aiCrossBrandVoice": "AI will use {{brandName}}'s voice and tone to write about {{otherBrandName}}'s products and insights",
    "platformsSelected_one": "Platforms ({{count}} selected)",
    "platformsSelected_other": "Platforms ({{count}} selected)",
    "multiPlatformHint": "One post is created per platform with the same copy. The character cap below is the tightest of all selected platforms.",
    "platformNotConnected": "{{platform}} is not connected to this brand. Connect it in brand settings to post here.",
    "platformConnectHint": "Some platforms aren't connected to this brand.",
    "platformConnectLink": "Connect them →",
    "syncFromPlatforms": "Sync from platforms",
    "syncTooltip": "Pull latest posts from Instagram, Facebook, LinkedIn, and X. Useful for IG, where new posts don't fire webhooks.",
    "syncStarted": "Sync started — new posts will appear shortly.",
    "syncFailed": "Sync failed. Try again in a moment.",
    "content": "Content",
    "charCount": "{{current}} / {{limit}}",
    "contentPlaceholder": "Write your post…",
    "instagramMediaRequired": "Instagram requires an image. Upload one or generate a template visual below.",
    "altTextRequiredForIG": "Alt text is required for Instagram posts — improves accessibility + reach.",
    "uploadMedia": "Upload image or video",
    "generateTemplate": "Generate a template visual (free, no AI cost)",
    "generateReel": "Generate as Instagram Reel (uses Kling 2.6 Pro · ~60 seconds)",
    "scheduleLater": "Schedule for later",
    "manualApprovedNote": "Manual posts skip review and go straight to APPROVED.",
    "scheduleCount_one": "Schedule {{count}} post",
    "scheduleCount_other": "Schedule {{count}} posts",
    "publishCount_one": "Publish {{count}} post",
    "publishCount_other": "Publish {{count}} posts",
    "topic": "Topic",
    "topicExample": "e.g. Product launch announcement, Weekly tips, Behind the scenes…",
    "topicHint": "Short description of what the post is about. Optional if you provide source text.",
    "contentType": "Content type",
    "contentTypeAuto": "Let AI pick",
    "contentTypeHint": "Drives the AI Visibility content-gap chart. Leave on \"Let AI pick\" if unsure — the model picks based on your topic.",
    "sourceText": "Source text (optional)",
    "sourceTextExample": "Paste existing copy and the AI will polish and adapt it for each platform.\n\nExample: a press release, a blog excerpt, or a Slack message you want to turn into a social post.",
    "sourceTextHint": "When provided, the AI keeps your facts and intent but rewrites tone, length, and formatting per channel. Leave blank to generate from the topic alone.",
    "generationNote": "Generated drafts land in your Review inbox. You can add a visual or reel to each post individually from there using the studio modals.",
    "writingPosts": "Writing your posts…",
    "generationEta": "Usually 5–15 seconds per platform",
    "platformDrafts_one": "{{count}} platform · 1 draft each",
    "platformDrafts_other": "{{count}} platforms · 1 draft each",
    "pickPlatform": "Pick at least one platform",
    "editPost2": "Edit post",
    "publishedLocked": "Published — content edits locked. Reschedule only.",
    "editSubtitle": "Update copy, hashtags, or schedule",
    "copy": "Copy",
    "hashtags": "Hashtags",
    "hashtagExample": "founder, building, dutch",
    "hashtagHint": "Comma-separated. The leading # is added when the post publishes.",
    "scheduledField": "Scheduled for",
    "scheduleHint": "Leave empty to keep as a draft. Editing a published post's schedule has no effect.",
    "saveFailed": "Failed to save changes.",
    "platformEditLimitation": "Most platforms don't expose an edit API.",
    "draftNote": "Saved drafts go back into your review inbox.",
    "visualStudio": "Visual Studio",
    "visualStudioSubtitle": "Generate AI images for this post",
    "imagePrompt": "Image prompt",
    "visualAiPromptHint": "Leave blank to let the AI write a prompt from the post content and brand context.",
    "compareModels": "Compare models",
    "compareModelsHint": "Run the same prompt against multiple models at once (1 image per model)",
    "toggleCompareMode": "Toggle compare mode",
    "model": "Model",
    "modelsToCompare": "Models to compare ({{count}} selected)",
    "aspectRatio": "Aspect ratio",
    "variations": "Variations",
    "imagesCount_one": "{{count}} image",
    "imagesCount_other": "{{count}} images",
    "advancedControls": "Advanced controls",
    "seed": "Seed",
    "seedPlaceholder": "Random (filled in after generation)",
    "seedHint": "Lock the seed to keep composition stable while editing the prompt.",
    "lock": "Lock",
    "guidanceScale": "Guidance scale: {{value}}",
    "guidanceScaleHint": "Higher = stricter prompt adherence. Lower = more creative. Default: 3.5",
    "inferenceSteps": "Inference steps: {{value}}",
    "inferenceStepsHint": "More steps = higher quality, more cost. Schnell default: 4. Dev default: 28.",
    "fluxProNote": "Flux Pro handles quality tuning internally — guidance and steps are not exposed.",
    "generatingImages": "Generating images…",
    "imagingGenEta": "Usually 10–20 seconds",
    "pickOne": "Pick one to use",
    "generatedVariation": "Generated variation",
    "selected": "Selected:",
    "useImage": "Use this image",
    "regenerate": "Regenerate",
    "regenerating": "Regenerating…",
    "regenerateFailed": "Regeneration failed",
    "reelStudio": "Reel Studio",
    "reelStudioSubtitle": "Generate a 9:16 video with Kling 2.6 Pro",
    "renderingOverlay": "Rendering overlay…",
    "renderingOverlayNote": "Compositing branded text via Puppeteer + ffmpeg (~30s)",
    "textOverlay": "Text overlay",
    "merkflowWatermark": "Merkflow watermark (admin)",
    "generatingReel": "Generating your reel…",
    "reelGenEta": "This usually takes 1–3 minutes",
    "reelGenEtaAudio": "Audio reels take longer — usually 5–8 minutes",
    "reelElapsed": "{{time}} elapsed",
    "runInBackground": "Run in background",
    "runInBackgroundNote": "You can safely close this — generation keeps running and the finished reel will appear on the post.",
    "view": "View",
    "videoGenFailed": "Video generation failed",
    "reelRetryHint": "Try adjusting the prompt and generating again",
    "noReelYet": "No reel generated yet",
    "reelSpec": "5–10 second video · 9:16 vertical format",
    "postCopy": "Post copy",
    "videoPrompt": "Video prompt",
    "autoGenerateFromPost": "Auto-generate from post",
    "videoPromptHint": "Describe the cinematic scene. 9:16 vertical, 5–10 seconds. No text overlays or real faces.",
    "reelWithAudio": "Generate with audio",
    "reelWithAudioHint": "Adds synchronised audio. Counts against your audio-on reel cap (much smaller than the audio-off cap). Auto-falls back to silent if your plan doesn't include audio reels.",
    "reelTips": "Tips for great reels",
    "reelTip1": "Describe motion and camera movement (pan, zoom, reveal)",
    "reelTip2": "Use specific visual details (lighting, textures, colours)",
    "reelTip3": "Keep it simple — one scene works better than many cuts",
    "reelTip4": "Avoid text, logos, or human faces in the prompt",
    "triggeringReel": "Triggering reel generation…",
    "bgGenerationNote": "Generation runs in the background — you can close this dialog",
    "reelPricing": "9:16 vertical · 10 seconds · counts as 1 reel against your monthly quota",
    "reelStep1": "Request submitted",
    "reelStep1Desc": "Queued at fal.ai",
    "reelStep2": "Generating video",
    "reelStep2Desc": "Rendering — 1–3 min (longer with audio)",
    "reelStep3": "Applying overlay",
    "reelStep3Desc": "Branding + text via ffmpeg",
    "reelStep4Desc": "Reel is ready",
    "carouselStudio": "Carousel Studio",
    "carouselSubtitle": "LinkedIn carousels get 3× the reach of plain text posts",
    "slidesGenerated_one": "{{count}} slide generated",
    "slidesGenerated_other": "{{count}} slides generated",
    "downloadPdf": "Download PDF",
    "carouselPlaceholder": "5–8 carousel slides will be generated",
    "carouselPlaceholderHint": "AI breaks your post into slides · Puppeteer renders the PDF",
    "carouselGenFailed": "Carousel generation failed.",
    "generatingCarousel": "Generating carousel…",
    "carouselGenEta": "AI writes slides, then Puppeteer renders the PDF (15–30 seconds)",
    "carouselReady_one": "{{count}} slide · PDF ready",
    "carouselReady_other": "{{count}} slides · PDF ready",
    "noCarousel": "No carousel yet",
    "regenerateCarousel": "Regenerate carousel",
    "generateCarousel": "Generate carousel",
    "postTrace": "Post lifecycle trace",
    "loadingTrace": "Loading audit log…",
    "traceEventCount_one": "{{count}} event in the audit log",
    "traceEventCount_other": "{{count}} events in the audit log",
    "traceLoadFailed": "Failed to load audit log.",
    "noTraceEvents": "No audit events for this post yet.",
    "traceNote": "The lifecycle log starts recording when V45 is deployed. Existing posts that predate it will only show events from new transitions going forward.",
    "statusLabel": "Status:",
    "reviewLabel": "Review:",
    "platformLabel": "Platform:",
    "publishedLabel": "Published:",
    "colPost": "Post",
    "colBrand": "Brand",
    "colPlatform": "Platform",
    "colStatus": "Status",
    "colDate": "Date",
    "inline": {
      "copyPlaceholder": "Write the post copy…",
      "tagPlaceholderEmpty": "Add a hashtag…",
      "tagPlaceholderMore": "Add another…",
      "removeTag": "Remove #{{tag}}",
      "hashtagCount": "{{count}} / {{max}} tags",
      "tagSoftWarn": "Over the recommended cap — reach may drop.",
      "saving": "Saving…",
      "saved": "Saved",
      "saveError": "Save failed",
      "editTooltip": "Click to edit hashtags",
      "editHint": "Enter / comma to add · Esc to close",
      "emptyHint": "Click to add hashtags"
    },
    "table": {
      "reach": "Reach",
      "engagement": "Engagement",
      "er": "ER"
    },
    "drawer": {
      "openTooltip": "Open analytics",
      "openOnPlatform": "Open on platform",
      "byBrand": "By {{brand}}",
      "noAnalytics": "No analytics yet. Numbers refresh after the next sync.",
      "reach": "Reach",
      "engagement": "Engagement",
      "er": "Engagement rate",
      "breakdown": "Breakdown",
      "likes": "Likes",
      "comments": "Comments",
      "shares": "Shares",
      "views": "Views",
      "clicks": "Clicks",
      "details": "Details",
      "publishedAt": "Published",
      "scheduledAt": "Scheduled",
      "createdAt": "Created",
      "account": "Account"
    },
    "traceSummary": "Sourced from post_events — every state transition is recorded.",
    "inferred": "inferred",
    "eventCreated": "Created",
    "eventEdited": "Edited",
    "eventVisualGenerated": "Visual generated",
    "eventCarouselGenerated": "Carousel generated",
    "eventReelPending": "Reel queued",
    "eventReelReady": "Reel ready",
    "eventReelFailed": "Reel failed",
    "eventApproved": "Approved",
    "eventRejected": "Rejected",
    "eventRegenerated": "Regenerated",
    "eventScheduled": "Scheduled",
    "eventPublishAttempt": "Publish attempt",
    "eventPublished": "Published",
    "eventPublishFailed": "Publish failed",
    "eventEditedOnPlatform": "Edited on platform",
    "eventDeletedOnPlatform": "Deleted on platform",
    "eventArchived": "Archived",
    "eventFallback": "Event",
    "decisionPublishConnectionResolved": "Publish — connection resolved",
    "decisionPublishSkipped": "Publish — skipped",
    "decisionDeletePlatformAttempted": "Delete — platform attempt",
    "decisionDeletePlatformSkippedIg": "Delete — IG not supported",
    "decisionDeletePlatform404": "Delete — complete",
    "decisionDeleteLocalOnly": "Delete — local only",
    "decisionVisualRoutedPuppeteer": "Visual — Puppeteer",
    "decisionVisualRoutedFal": "Visual — fal.ai",
    "decisionVisualFalFallback": "Visual — fal.ai fallback",
    "decisionReelRoutedMock": "Reel — mock",
    "decisionSyncMediaClassified": "Sync — media type",
    "contentTypeEducational": "Educational",
    "contentTypeSocialProof": "Social proof",
    "contentTypeThoughtLeadership": "Thought leadership",
    "contentTypeProductHighlight": "Product",
    "contentTypeIndustryReaction": "Industry",
    "contentTypeBehindTheScenes": "Behind the scenes",
    "editedOnPlatform": "Edited on platform · {{ago}}",
    "crossBrandPostedBy": "Posted by",
    "crossBrandAbout": "About",
    "twitterTruncateWarning": "{{count}} chars — this post will auto-split into a thread on X (280 chars per tweet).",
    "aiVisualOnPublish": "AI visual will be generated on publish",
    "chooseVisual": "Choose visual",
    "storylineFallback": "Storyline",
    "userUploadedMedia": "User-uploaded media",
    "aiVisualIgnored": "AI visual ignored",
    "generateVisual": "Generate visual",
    "generateReelShort": "Generate reel",
    "createReel": "Create Reel",
    "trace": "Trace",
    "traceLifecycle": "Trace lifecycle",
    "viewLive": "View live",
    "publishNow": "Publish now",
    "republish": "Republish",
    "republishConfirm": "Republish this post? The version on the platform will be deleted (where supported) and a fresh copy goes out within a minute.",
    "altText": {
      "label": "Alt text",
      "optionalHint": "— optional, improves reach",
      "whyTitle": "Why fill this in?",
      "whyAlgo": "Instagram's algorithm reads alt text to understand what your image is about. It decides who sees your post partly based on this description.",
      "whySearch": "Alt text also gets indexed by Google and AI search tools, so a good description helps people find you outside Instagram too.",
      "whyHowto": "Plain language works best. 1–2 sentences describing what's in the image, with a keyword or two. No hashtags.",
      "placeholder": "Dashboard showing a weekly social media content plan for a multi-brand operator, with post previews across LinkedIn and Instagram",
      "bodyCaption": "Describes the image for accessibility and Instagram's search index. Keep it under 280 characters for best reach. Leave blank if unsure — posting without alt text still works, it just helps less."
    },
    "playReel": "Play reel",
    "viewFullScreen": "View full screen",
    "postVisual": "Post visual",
    "postVisualFullSize": "Post visual — full size",
    "carouselSlide1": "Slide 1",
    "carouselReady": "Carousel ready",
    "carouselSwipe": "Swipe →",
    "commentsWithCount": "Comments · {{count}}",
    "someoneCommenter": "Someone",
    "replyPrefix": "Reply:",
    "showLess": "Show less",
    "showAllCount": "Show all {{count}}",
    "noAccountConnected": "No {{platform}} account connected",
    "postAs": "Post as",
    "postAsAccount": "Post as account",
    "selectAccount": "Select an account…",
    "unnamedAccount": "(unnamed)",
    "generationFailed": "Generation failed",
    "commitFailed": "Commit failed",
    "noImageSelected": "No image selected",
    "uploadYourOwn": "Upload your own image",
    "uploadYourOwnHint": "Skip AI generation — upload a ready image (JPG/PNG/WebP).",
    "chooseImage": "Choose image",
    "statusPublished": "Published",
    "statusSynced": "Synced from platform",
    "syncedShort": "Synced",
    "statusScheduled": "Scheduled",
    "statusDraft": "Draft",
    "statusPending": "Pending",
    "statusApproved": "Approved",
    "statusRejected": "Rejected",
    "statusFailed": "Failed",
    "statusInReview": "In review",
    "statusPendingPublish": "Publishing",
    "statusArchived": "Archived"
  },
  "analytics": {
    "title": "Analytics",
    "linkedinImport": {
      "button": "Import LinkedIn data",
      "tooltip": "Upload a LinkedIn analytics XLS export to fill in metrics that LinkedIn doesn't expose via API.",
      "pickerTitle": "Pick a LinkedIn account",
      "pickerHint": "You have multiple LinkedIn accounts. Choose the one this export belongs to."
    },
    "deltaTooltip": "vs previous period (same length window before the current selection)",
    "reach": "Reach",
    "totalReach": "Total reach",
    "engagements": "Engagements",
    "impressions": "Impressions",
    "likes": "Likes",
    "comments": "Comments",
    "shares": "Shares",
    "followers": "Followers",
    "noData": "No analytics data yet.",
    "postsPublished": "Posts published",
    "zeroNote": "Analytics are reported by the platform with a 24–48h delay.",
    "postsByType": "Posts by type",
    "performanceOverTime": "Performance over time",
    "topPosts": "Top posts",
    "last7days": "Last 7 days",
    "last30days": "Last 30 days",
    "last90days": "Last 90 days",
    "published": "Published",
    "withReach": "With reach",
    "withLikes": "With likes",
    "withComments": "With comments",
    "withShares": "With shares",
    "account": "Account",
    "filterByAccount": "Filter by posting account",
    "allAccounts": "All accounts",
    "reachOverview": "Reach overview",
    "last30LiveData": "Last 30 days · live data",
    "noReachYet": "No reach data yet. Publish a post to start tracking.",
    "postsOverTime": "Posts over time",
    "last30ByPlatform": "Last 30 days · by platform",
    "noPostsInWindow": "No posts published in this window yet.",
    "platformSplit": "Platform split",
    "byReach": "By reach",
    "byPostsPublished": "By posts published",
    "noDataYet": "No data yet",
    "contentFunnel": "Content funnel",
    "topPerformingPosts": "Top performing posts",
    "noPublishedPostsPeriod": "No published posts found for this period.",
    "colPost": "Post",
    "colPlatform": "Platform",
    "colAccount": "Account",
    "colBrand": "Brand",
    "colPublished": "Published",
    "colReach": "Reach",
    "colLikes": "Likes",
    "colER": "ER",
    "noPostsInWindowShort": "No posts in this window.",
    "avgEngagement": "Avg engagement",
    "videoViews": "Video views",
    "openBreakdown": "Open breakdown for {{label}}",
    "breakdownTitle": "Breakdown",
    "breakdownSubtitle": "{{count}} posts contributing — top 50 shown",
    "breakdownEmpty": "No posts contributed to this metric in the current period.",
    "bestPostReach": "Best post reach",
    "totalLikes": "Total likes",
    "dataIntelligence": "Data Intelligence",
    "dataIntelligenceSubtitle": "Real-time insights and post performance",
    "filter_today": "Today",
    "filter_week": "Week",
    "filter_month": "Month",
    "filter_year": "Year",
    "syncNow": "Sync now",
    "export": {
      "button": "Export",
      "csv": "Download CSV",
      "pdf": "Download PDF report",
      "generating": "Generating PDF…"
    },
    "brandLabel": "Brand",
    "allBrands": "All brands",
    "tabOverview": "Overview",
    "reachZeroTitle": "Reach and engagement showing zero?",
    "reachZeroIntro": "Meta's API returns 0 for accounts with fewer than 100 followers, and data can take up to 48 hours to appear after publishing. This is a confirmed Meta API limitation — not a sync error. Posts published shows",
    "reachZeroAccurate": "which is accurate.",
    "runSync": "Run a sync",
    "toPullLatest": "to pull the latest data.",
    "noPlatformData": "No platform data yet. Connect an account to start tracking.",
    "platformBreakdown": "Platform breakdown",
    "perPlatformTotals": "Per-platform totals for this period",
    "topPostThisPeriod": "Top post this period",
    "unknownBrand": "Unknown brand",
    "unpublished": "Unpublished",
    "platform": {
      "tabLabel": {
        "linkedin": "LinkedIn",
        "instagram": "Instagram",
        "facebook": "Facebook",
        "x": "X",
        "blog": "Blog"
      },
      "tile": {
        "impressions": "Impressions",
        "reach": "Reach",
        "uniqueReach": "Unique reach",
        "engagementRate": "Engagement rate",
        "ctr": "Click-through rate",
        "totalReactions": "Total reactions",
        "saves": "Saves",
        "totalInteractions": "Total interactions",
        "profileVisits": "Profile visits",
        "likes": "Likes",
        "comments": "Comments",
        "shares": "Shares",
        "linkClicks": "Link clicks",
        "retweets": "Retweets",
        "quotes": "Quotes",
        "replies": "Replies",
        "bookmarks": "Bookmarks"
      },
      "topPostsTitle": "Top performing posts",
      "noPostsInWindow": "No posts on this platform in the selected window.",
      "noTimeseriesYet": "No daily data yet — come back after the next sync.",
      "noEngagementYet": "No engagement reported yet",
      "noEngagementHint": "Platforms can take 24–48h to report impressions on new posts.",
      "noReactionsYet": "No reactions yet on this period's posts.",
      "heroHintImpressionsReach": "Impressions and unique reach over time",
      "heroHintReach": "Reach over time",
      "linkedin": {
        "heroTitle": "Reach over time",
        "engagementMixTitle": "Engagement mix",
        "gaugeTitle": "Engagement rate",
        "gaugeHint": "vs B2B benchmark",
        "benchmarkCaption": "B2B benchmark: {{benchmark}}%",
        "sortBy": "Sorted by total engagement",
        "org": {
          "title": "{{page}} — page stats",
          "followers": "Followers",
          "followerGain": "New followers (organic)",
          "pageViews": "Page views",
          "shareEngagement": "Post engagement",
          "followerTrend": "Follower growth",
          "pageViewsBySection": "Page views by section",
          "trendEmpty": "Follower trend appears after a few days of syncing.",
          "pageViewsEmpty": "No page-view data yet.",
          "empty": "LinkedIn page stats sync nightly — check back tomorrow."
        }
      },
      "instagram": {
        "heroTitle": "Reach + Saves",
        "heroHint": "Saves are Instagram's high-value engagement signal",
        "contentMixTitle": "Reels vs Feed",
        "saveRateTitle": "Save rate",
        "saveRateHint": "saves per reach",
        "saveRateCaption": "1% decent · 3% strong",
        "profileVisitsEmpty": "Profile visits requires expanded API access — track follow-up.",
        "reels": "Reels",
        "feed": "Feed posts",
        "reelsShare": "of recent posts are reels",
        "reelViews": "total reel views",
        "sortBy": "Sorted by saves"
      },
      "facebook": {
        "heroTitle": "Reach over time",
        "reactionsTitle": "Reactions by type",
        "sentimentTitle": "Sentiment ratio",
        "sentimentHint": "positive : negative",
        "sentimentCaption": "5:1 healthy · 1:1 mixed",
        "reactions": {
          "like": "Like",
          "love": "Love",
          "haha": "Haha",
          "wow": "Wow",
          "sorry": "Sorry",
          "anger": "Anger"
        },
        "videoTitle": "Video performance",
        "videoSummary": "{{views}} total video views in this window.",
        "sortBy": "Sorted by reactions"
      },
      "x": {
        "engagementMixTitle": "Engagement mix",
        "engagementMixHint": "Likes / retweets / quotes / replies stacked daily",
        "bookmarkRateTitle": "Bookmark rate",
        "bookmarkRate": "Bookmark rate",
        "quoteMagnetTitle": "Quote magnet",
        "quoteMagnetUnit": ":1 RT",
        "quoteMagnetHint": "quotes per retweet",
        "quoteMagnetCaption": "1:5+ sparks discussion",
        "urlClicksTitle": "URL clicks",
        "urlClicksHint": "Real link clicks (X non-public metrics)",
        "profileVisitsHint": "Visits driven from these posts",
        "sortBy": "Sorted by impressions"
      }
    }
  },
  "chatbot": {
    "title": "Merkflow AI",
    "open": "Open AI assistant",
    "history": "History",
    "newConversation": "New conversation",
    "placeholder": "Ask me anything…",
    "send": "Send",
    "noConversations": "No conversations yet. Start one!",
    "deleteConfirm": "Delete?",
    "delete": "Delete",
    "cancel": "Cancel",
    "usageCounter": "{{used}} / {{limit}} messages this month",
    "usageUnlimited": "Unlimited messages",
    "limitReached": "You've reached the message limit for your {{plan}} plan ({{limit}}/month). Upgrade to Pro for 500 messages per month.",
    "upgradeLink": "Upgrade",
    "welcomeTitle": "Hi! I'm the Merkflow AI assistant.",
    "welcomeBody": "I can help you create content, understand your analytics, troubleshoot connections, and more. What can I help you with?",
    "welcomePrompt1": "Write a LinkedIn post about our latest feature",
    "welcomePrompt2": "Why isn't my Instagram connection working?",
    "welcomePrompt3": "Explain my GEO score",
    "disabled": "The AI assistant is temporarily unavailable.",
    "thinking": "Thinking…",
    "errorGeneric": "Something went wrong. Please try again.",
    "back": "Back to history",
    "close": "Close",
    "openReview": "Open Review inbox"
  },
  "engagement": {
    "title": "Engagement",
    "subtitle": "Replies, comments, and mentions across every connected platform.",
    "inbox": "Inbox",
    "noMessages": "No messages.",
    "noNewMessages": "No new messages",
    "emptyDescription": "When followers comment or mention you, their messages appear here.",
    "allItems_one": "All items ({{count}})",
    "allItems_other": "All items ({{count}})",
    "markRead": "Mark as read",
    "markResolved": "Mark as resolved",
    "resolve": "Resolve",
    "reply": "Reply",
    "replySent": "Reply sent",
    "deleteOwn": "Delete reply",
    "deleteOwnTooltip": "Delete this reply on the platform and remove it locally.",
    "deleteOwnConfirm": "Delete this reply from the platform? This can't be undone.",
    "comment": "Comment",
    "mention": "Mention",
    "unread": "Unread",
    "aiSuggestion": "AI suggestion",
    "regenerating": "Regenerating…",
    "regenerate": "Regenerate",
    "useSuggestion": "Use this suggestion →",
    "yourReply": "Your reply",
    "placeholderReply": "Write a response...",
    "sendReply": "Send reply",
    "selectMessage": "Select a message",
    "selectDescription": "Pick an item from the list on the left to read and reply.",
    "noNewComments": "No new comments yet",
    "appearAsTheyArrive": "Engagements appear here as they come in",
    "viewAllNotifications": "View all notifications →",
    "commented": "commented",
    "reacted": "Liked",
    "sentimentPositive": "Positive",
    "sentimentNegative": "Negative",
    "sentimentNeutral": "Neutral",
    "filterAll": "All",
    "filterUnread": "Unread",
    "filterMentions": "Mentions",
    "filterComments": "Comments",
    "filterResolved": "Resolved",
    "postContextUnavailable": "Post context unavailable",
    "viewOnPlatform": "View on {{platform}}",
    "viaConnection": "via {{name}}",
    "contentUnavailable": "Content could not be loaded",
    "replyingTo": "Replying to @{{handle}}",
    "resolveThread": "Resolve thread",
    "markAsRead": "Mark as read",
    "emptyAllFirst": "No engagement yet. Comments, replies, and mentions across your connected accounts will show up here.",
    "emptyAllReturning": "You're all caught up.",
    "emptyUnread": "You're all caught up.",
    "emptyMentions": "No mentions yet. When someone @-tags one of your brands on Instagram, it'll appear here.",
    "emptyComments": "No comments yet.",
    "emptyResolved": "Nothing resolved yet.",
    "selectThread": "Select a thread to see the conversation.",
    "threadUnreadCount_one": "{{count}} unread",
    "threadUnreadCount_other": "{{count}} unread",
    "threadItemCount_one": "{{count}} comment",
    "threadItemCount_other": "{{count}} comments",
    "mentionedYou": "mentioned you",
    "likedYourPost": "liked your post",
    "linkedinMember": "LinkedIn member",
    "you": "you",
    "allBrands": "All brands"
  },
  "connections": {
    "title": "Connections",
    "subtitle": "Social accounts connected to this workspace.",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "reconnect": "Reconnect",
    "connected": "connected",
    "expired": "Expired",
    "noConnections": "No accounts connected yet",
    "connectSuccess": "{{platform}} connected successfully.",
    "linkedinPickerTitle_one": "You added {{count}} LinkedIn page",
    "linkedinPickerTitle_other": "You added {{count}} LinkedIn pages",
    "linkedinPickerSubtitle": "Keep the ones you want — remove any you don't need. You can always reconnect later.",
    "linkedinPickerRemove": "Remove",
    "linkedinPickerDone": "Done",
    "connectPlatform": "Connect {{platform}}",
    "connectAnother": "+ Connect another {{platform}}",
    "linkedinPersonal": "+ Personal LinkedIn",
    "linkedinCompany": "+ LinkedIn company page",
    "importAnalytics": {
      "button": "Import analytics",
      "title": "Import LinkedIn analytics",
      "subtitle": "Upload the analytics export for {{name}}.",
      "howTo": "On LinkedIn, open the page admin (or your personal analytics) and click \"Export\". Save the file and drop it here. We'll match the rows to your Merkflow posts by LinkedIn activity URN, then fill in impressions, clicks, likes, comments, and reposts.",
      "dropzone": "Click to choose a file",
      "start": "Start import",
      "uploadError": "Could not upload the file. Make sure it's the LinkedIn XLS export.",
      "canCloseHint": "You can close this window — the import keeps running in the background.",
      "status": {
        "pending": "Queued…",
        "running": "Parsing and matching posts…"
      },
      "done": "Import complete",
      "failed": "Import failed",
      "tryAgain": "Try another file",
      "completedToast": "LinkedIn analytics imported.",
      "backfillLabel": "Create Merkflow posts for unmatched rows",
      "backfillHint": "Recommended for company exports — adds the historical post copy + analytics to this brand's dashboard. Requires the connection to be set as the LinkedIn default for a brand. Personal-export rows can't be backfilled (LinkedIn doesn't include the post text).",
      "backfillPersonalNote": "Not available for personal accounts — LinkedIn's personal export doesn't include the post text, so we can't create posts from it. Metrics still apply to posts Merkflow already knows about.",
      "summary": {
        "format": "Format:",
        "totalRows": "Posts in export:",
        "matchedUrn": "Matched directly (URN):",
        "matchedFuzzy": "Fuzzy-matched:",
        "backfilled": "Posts created from export:",
        "unmatched": "Unmatched:",
        "followerUpdated": "Follower count updated.",
        "unmatchedHint": "These posts could not be matched to a Merkflow post:"
      }
    },
    "linkedinManual": "+ Manual company page",
    "linkedinManualHint": "No OAuth needed. Generate posts in Merkflow, then copy them to LinkedIn manually. Useful while Community Management API approval is pending.",
    "linkedinManualTitle": "Add a manual LinkedIn company page",
    "linkedinManualDescription": "Create a stub connection without OAuth. Generated posts will land in your review inbox; publishing requires copying the content to LinkedIn manually.",
    "linkedinManualNameLabel": "Display name",
    "linkedinManualNamePlaceholder": "e.g. Ludicrous Dukes",
    "linkedinManualNameRequired": "Display name is required.",
    "linkedinManualUrlLabel": "Company page URL (optional)",
    "linkedinManualUrlHint": "Tip: paste the LinkedIn admin URL (e.g. https://www.linkedin.com/company/89594379/admin/dashboard/) — \"Open in LinkedIn\" will then jump straight to the page-admin compose. Without it we fall back to the public page and you click \"Admin tools\" yourself.",
    "linkedinManualSubmit": "Add page",
    "linkedinManualError": "Could not create the manual connection.",
    "manualOnly": "Manual only",
    "manualOnlyHint": "No OAuth token. Posts assigned to this connection have to be published manually from LinkedIn.",
    "connectDescription": "Connect Instagram, Facebook, or LinkedIn to start publishing with Merkflow.",
    "expiredMessage": "Your connection has expired. Please reconnect.",
    "none": "No connections yet.",
    "disconnectConfirm": "Disconnect {{platform}}? This will stop publishing to this account.",
    "lastSynced": "Last synced {{time}}",
    "accounts_one": "{{count}} account",
    "accounts_other": "{{count}} accounts",
    "oauthError": "Could not start {{platform}} OAuth.",
    "reconnectToUpdate": "reconnect to update",
    "tokenExpires": "Token expires {{date}}",
    "followers": "{{count}} followers",
    "webhookSettings": "Webhook Settings",
    "metaWebhooks": "Meta Webhooks",
    "metaWebhooksDescription": "Real-time comment notifications from Facebook and Instagram. Subscribe your connected pages to receive instant engagement updates.",
    "xWebhooks": "X Webhooks",
    "xWebhooksDescription": "Real-time mention and reply notifications from X. New connections subscribe automatically — use this to retrofit accounts that connected before webhooks shipped, or as a rescue if a subscription drops.",
    "subscribeAll": "Subscribe all",
    "subscribing": "Subscribing...",
    "subscriptionSuccess_one": "Subscribed {{count}} account to webhooks.",
    "subscriptionSuccess_other": "Subscribed {{count}} accounts to webhooks.",
    "subscriptionFailed": "Failed: {{failed}} of {{total}} account(s) could not subscribe. Reconnect with the updated scope.",
    "noFacebookPages": "No Facebook pages found to subscribe.",
    "noXAccounts": "No X accounts found to subscribe — or all are already subscribed.",
    "subscriptionError": "Failed to subscribe accounts: {{message}}",
    "webhookActive": "Webhook active",
    "webhookNeedsAuth": "Webhook: needs extra auth",
    "webhookPending": "Webhook: pending",
    "webhookNotRegistered": "Webhook: URL not registered",
    "webhookNotSubscribed": "Webhook: not subscribed",
    "webhookTokenExpired": "Webhook: token expired — reconnect",
    "webhookMissingAccount": "Webhook: account not linked",
    "webhookProblem": "Webhook: issue",
    "xEnableWebhooksHint": "Real-time mentions need a separate one-time authorization. Click below to grant permission.",
    "xEnableWebhooks": "Enable webhooks",
    "xWebhookEnabledSuccess": "X webhook authorization granted. Mentions will now arrive in real time.",
    "xWebhookEnabledError": "X webhook authorization failed: {{message}}",
    "viewTrace": "View trace",
    "renameAccount": "Click to rename",
    "unclaimed": "Not linked to a brand",
    "unclaimedHint": "No brand uses this account by default. Set it as a default on a brand to include it in scheduled posts.",
    "traceTitle": "Connection activity",
    "traceEmpty": "No activity yet. Sync and publish events will appear here.",
    "traceInputs": "in",
    "traceOutputs": "out",
    "traceFallback": "Event",
    "traceBrandResolved": "Brand resolved",
    "traceBrandSkipped": "Brand skipped",
    "traceSyncComplete": "Sync complete",
    "traceSyncFailed": "Sync failed",
    "traceTokenRefreshed": "Token refreshed",
    "traceTokenExpired": "Token expired",
    "traceWebhookReceived": "Webhook received",
    "traceWebhookRejected": "Webhook rejected"
  },
  "workspace": {
    "title": "Workspace",
    "members": "Members",
    "inviteMembers": "Invite members",
    "createWorkspace": "Create workspace",
    "createNew": "Create new workspace",
    "switchWorkspace": "Switch workspace",
    "selectWorkspace": "Select workspace",
    "paused": {
      "title": "This workspace is paused",
      "body": "All actions are read-only. Upgrade to a paid plan to continue, or switch to another workspace.",
      "switchHint": "or switch workspace ↑"
    },
    "trialExpired": {
      "title": "Your trial has ended",
      "body": "Read-only mode is active until you upgrade. New posts, generations, and connections are disabled."
    },
    "createTitle": "Create workspace",
    "createSubtitle": "Each workspace has its own brands, members, and connections.",
    "nameLabel": "Workspace name",
    "namePlaceholder": "Acme Marketing",
    "createNote": "You'll be the owner. Invite teammates from Settings → Members after creating.",
    "creating": "Creating…",
    "createButton": "Create workspace",
    "nameRequired": "Workspace name is required",
    "role_OWNER": "owner",
    "role_ADMIN": "admin",
    "role_MEMBER": "member",
    "role_VIEWER": "viewer"
  },
  "plans": {
    "trial": "Trial",
    "starter": "Starter",
    "pro": "Pro",
    "agency": "Agency",
    "upgradeRequired": "Upgrade required",
    "upgrade": "Upgrade",
    "trialDaysLeft": "{{days}} days left in trial",
    "trialExpired": "Trial expired",
    "trialEnds": "Trial ends {{date}}",
    "daysLeft": "{{count}} days left",
    "adminOverride": "Admin override",
    "planLocked": "Plan locked by admin — no billing applies."
  },
  "billing": {
    "title": "Billing",
    "subtitle": "Plan, usage and subscription for this workspace.",
    "currentPlan": "Current plan",
    "upgradeCta": "Upgrade plan",
    "trialEnded": "Your trial has ended. Upgrade to continue using this workspace.",
    "trialEndsIn_one": "Your trial ends in {{days}} day ({{date}})",
    "trialEndsIn_other": "Your trial ends in {{days}} days ({{date}})",
    "trialEndsToday": "Your trial ends today — upgrade before end of day to keep your workspace.",
    "renewsOn": "Renews {{date}}",
    "cancelledAccessUntil": "Subscription cancelled — access until {{date}}",
    "subscriptionEnded": "Your subscription has ended. Reactivate a paid plan to keep using this workspace.",
    "processing": "Payment is processing… your plan will update once Mollie confirms.",
    "processingTimeout": "Still processing. This sometimes takes a few minutes — refresh shortly.",
    "cancelSubscription": "Cancel subscription",
    "cancelling": "Cancelling…",
    "ownerOnly": "Only the workspace owner can change the plan.",
    "cancelConfirm": "Cancel your subscription? Your workspace will be paused at the end of the current billing period.",
    "usageThisMonth": "Usage this month",
    "monthly": "Monthly",
    "annual": "Annual",
    "annualSavings": "save 2 months",
    "toggleAnnual": "Toggle annual pricing",
    "currentPlanButton": "Current plan",
    "startPlan": "Start {{plan}}",
    "switchPlan": "Switch to {{plan}}",
    "ownerOnlyMessage": "Only workspace owners can change the plan.",
    "loadingPlan": "Loading workspace plan…",
    "notAvailable": "— not available",
    "accountSuspended": "Account suspended",
    "suspendedDescription": "Your account has been temporarily suspended. Upgrade your plan or contact support to restore access.",
    "upgradeToRestore": "Upgrade plan",
    "perYearShort": "year",
    "perMonthShort": "mo",
    "starterHighlight1": "60 AI posts / month",
    "starterHighlight2": "1 brand · 2 platforms",
    "starterHighlight3": "1 team member",
    "starterHighlight4": "Basic analytics",
    "proHighlight1": "300 AI posts / month",
    "proHighlight2": "5 brands · all platforms",
    "proHighlight3": "3 team members",
    "proHighlight4": "fal.ai visual generation",
    "proHighlight5": "50 reels / month",
    "proHighlight6": "Full analytics + prime time",
    "agencyHighlight1": "Unlimited posts + brands",
    "agencyHighlight2": "Unlimited team members",
    "agencyHighlight3": "Meta Ads access",
    "agencyHighlight4": "100 reels / month",
    "agencyHighlight5": "Thought-leader ads",
    "agencyHighlight6": "Priority support",
    "detailsTitle": "Billing details",
    "detailsSubtitle": "Company details for your invoices — VAT number, registration and billing address.",
    "companyName": "Company name",
    "billingEmail": "Billing email",
    "vatNumber": "VAT number (BTW)",
    "registrationNumber": "Registration number (KVK)",
    "addressLine1": "Address",
    "addressLine2": "Address line 2",
    "postalCode": "Postal code",
    "city": "City",
    "countryCode": "Country code",
    "detailsSaved": "Billing details saved",
    "detailsSaveFailed": "Could not save billing details",
    "detailsLastSaved": "Last saved {{date}}",
    "customerType": "Customer type",
    "customerType_business": "Business",
    "customerType_private": "Private",
    "detailsRequiredForCheckout": "Please complete your billing details below before upgrading.",
    "invoicesTitle": "Invoices",
    "invoicesSubtitle": "Invoices for your subscription and top-up payments, sent to your billing email.",
    "invoiceDate": "Date",
    "invoiceDescription": "Description",
    "invoiceAmount": "Amount",
    "invoiceStatus": "Status",
    "invoiceCreated": "Sent",
    "invoicePending": "Processing",
    "invoiceView": "View"
  },
  "cadence": {
    "title": "Content Cadence",
    "subtitle": "Automatic post generation schedule for your brands",
    "viewOnly": "View only.",
    "viewOnlyDescription": "Only the workspace owner can change cadence settings. You can still see what's configured for each brand below.",
    "postsPerWeek": "Posts per week",
    "noCadence": "No cadence",
    "onTrack": "On track",
    "needsAttention": "Needs attention",
    "schedule": "Schedule",
    "board": "Board",
    "list": "List",
    "addPlatform": "Add {{platform}}",
    "nextGeneration": "Next generation",
    "recentActivity": "Recent activity",
    "mondayInfo": "Cadence drafts run automatically at 06:00 — depending on the generation mode above (Weekly or Daily). The schedule sets when each post publishes. Drafts land in the",
    "noCadenceTooltip": "No active cadence — Merkflow is not generating posts for this brand yet.",
    "onTrackTooltip": "On track: {{fillPct}}% of this month's target ({{actual}} of {{expected}} posts) is already in flight.",
    "needsAttentionTooltip": "Needs attention: only {{fillPct}}% of this month's target ({{actual}} of {{expected}} posts) has been generated so far. The threshold for \"on track\" is 60%.",
    "noPlatforms": "No platforms",
    "scheduleHeader": "{{brand}} — schedule",
    "platform": "Platform",
    "perWeek": "/week",
    "days": "Days",
    "time": "Time",
    "active": "Active",
    "noPlatformsConfigured": "No platforms configured.",
    "forApproval": "for approval before publishing.",
    "contentDistribution": "Content distribution",
    "self": "{{name}} (self)",
    "percentTotal": "{{total}}% total",
    "mustEqual100": "must equal 100%",
    "autoSaves": "Auto-saves",
    "addBrandToDistribution": "+ Add brand to distribution",
    "createBrandFirst": "Create a brand first to configure its cadence.",
    "activeCount": "{{count}} active",
    "postsPerWeekLabel": "Posts / week",
    "postsCount_one": "{{count}} post",
    "postsCount_other": "{{count}} posts",
    "reviewInboxLabel": "Review inbox",
    "removeCadence": "Remove cadence",
    "mondayAt0600": "Monday at 06:00",
    "noCadenceSet": "No cadence set",
    "noRecentPosts": "No recent posts.",
    "justNow": "just now",
    "viewReviewInbox": "View review inbox →",
    "boardBrandSummary_one": "{{count}} brand · {{posts}} posts / week",
    "boardBrandSummary_other": "{{count}} brands · {{posts}} posts / week",
    "noBrandsForPlatform": "No brands generating {{platform}} content yet.",
    "noCadencesConfigured": "No cadences configured yet. Switch to the Schedule view to add one.",
    "timingHint": "The cron runs daily at 06:00. Per-platform days/times here decide when each post publishes — generation timing depends on the mode below. Hit \"Run now\" to generate immediately for testing.",
    "modeTitle": "Generation mode",
    "modeSubtitle": "How and when cadence drafts are produced for this workspace.",
    "modeWeekly": "Weekly batch",
    "modeWeeklyDescription": "All week's drafts generated Monday at 06:00.",
    "modeWeeklyTooltip": "Monday 06:00 produces the full set of drafts for every preferred day of the week. You'll see a wave of pending posts at the start of the week and have until each post's scheduled time to review.",
    "modeDaily": "Daily, on each preferred day",
    "modeDailyDescription": "One draft per cadence on its scheduled day at 06:00.",
    "modeDailyTooltip": "On each preferred day at 06:00, only that day's draft is generated. Drafts feel fresher (can react to current events) but the review window shrinks to a few hours before publish time.",
    "advanced": "Advanced",
    "contentTypesLabel": "Content types",
    "contentTypesHint": "Select which post angles this cadence rotates through. Leave none selected to use all 6 (default).",
    "themeLabel": "Recurring theme",
    "themePlaceholder": "e.g. this quarter we're focused on AI-powered logistics",
    "themeHint": "Optional. Injected into the AI prompt as a focus area when it naturally fits the post.",
    "runNow": "Run now",
    "runNowTooltip": "Generate this week's drafts now — skips the Monday 06:00 cron",
    "runNowSuccess_one": "{{count}} post added to Review",
    "runNowSuccess_other": "{{count}} posts added to Review",
    "runNowFailed": "Failed — check logs"
  },
  "usage": {
    "title": "Usage",
    "subtitle": "Track your Anthropic + fal.ai spend and token consumption this month.",
    "subtitleNew": "What you pay this month, what you've used, and what you have left.",
    "postsGenerated": "Posts generated",
    "imagesGenerated": "Images generated",
    "reelsGenerated": "Reels generated",
    "thisMonth": "This month",
    "ofLimit": "of {{limit}}",
    "unlimited": "Unlimited",
    "resets": "Resets {{date}}",
    "aiPosts": "AI posts",
    "images": "Images",
    "reels": "Reels",
    "costThisMonth": "This month (€)",
    "anthropicCalls": "Anthropic calls",
    "falAiCalls": "fal.ai calls",
    "tokensUsed": "Tokens used",
    "byModel": "By model",
    "noUsageYet": "No usage yet this month",
    "model": "Model",
    "requests": "Requests",
    "tokens": "Tokens",
    "costEuro": "Cost (€)",
    "spend": {
      "title": "This month",
      "subtitle": "Plan + extras combined.",
      "plan": "Plan",
      "topups": "Top-ups",
      "total": "Total",
      "totalSubtitle": "Plan + top-ups this month.",
      "month": "month",
      "free": "Included with trial",
      "complimentary": "Complimentary (admin grant)",
      "renewsOn": "Renews {{date}}",
      "renewsMonthly": "Renews monthly",
      "trialEnds": "Trial ends {{date}}",
      "packsCount_one": "{{count}} pack purchased",
      "packsCount_other": "{{count}} packs purchased"
    },
    "utilization": {
      "title": "Plan utilisation",
      "subtitle": "What you've used this month against your plan limits.",
      "unlimitedCount": "{{used}} (unlimited)",
      "atCapBuy": "At cap — buy more capacity",
      "nearCapBuy": "Almost at cap — top up?"
    },
    "topups": {
      "title": "Top-up balance",
      "subtitle": "Extras you bought. Older packs drain first.",
      "buyMore": "Buy more",
      "empty": "No top-ups bought yet. If you hit a plan cap mid-month, you can buy extra capacity here.",
      "fullyUsed": "Fully used",
      "neverExpires": "—",
      "colPack": "Pack",
      "colPaid": "Paid",
      "colRemaining": "Remaining",
      "colPurchased": "Purchased",
      "colExpires": "Expires"
    },
    "trend": {
      "title": "Activity (last 30 days)",
      "subtitle": "What you generated, day by day.",
      "empty": "No activity in the last 30 days."
    },
    "resource": {
      "posts": "Posts",
      "images": "Images",
      "reels_no_audio": "Reels (no audio)",
      "reels_with_audio": "Reels (with audio)",
      "carousels": "Carousels",
      "brands": "Brands",
      "platforms": "Platforms connected",
      "team_members": "Team members",
      "api_keys": "API keys"
    }
  },
  "onboarding": {
    "title": "Tell us about {{brand}}",
    "whatBringsYou": "What brings you here?",
    "stepCount": "Step {{step}} of 3",
    "stepCountBeta": "One quick step",
    "competitors": {
      "title": "Know your competitors?",
      "subtitle": "Add up to 3 competitors so we can compare your AI visibility against theirs from day one.",
      "skip": "Skip",
      "save": "Save & continue",
      "name": "Competitor name",
      "url": "Website (optional)"
    },
    "pickOptionDescription": "Pick the option that fits your situation best. You can change this later.",
    "solo": "Solo / creator",
    "soloDescription": "Personal brand, side project",
    "business": "Business",
    "businessDescription": "One company, multiple channels",
    "agencyLabel": "Agency",
    "agencyDescription": "Managing brands for clients",
    "setupWorkspace": "Set up your workspace",
    "setupDescription": "Create your first workspace and add a brand.",
    "beta": {
      "title": "Tell us about your brand",
      "subtitle": "You're in. Drop your brand name and website and we'll take it from there."
    },
    "workspaceName": "Workspace name",
    "workspaceNamePlaceholder": "My workspace",
    "firstBrandName": "First brand name",
    "brandNamePlaceholder": "My brand",
    "brandWebsite": "Brand website",
    "websitePlaceholder": "https://example.com",
    "finishSetup": "Finish setup",
    "whatYouDo": "What do you do?",
    "idealCustomer": "Who is your ideal customer?",
    "recentWins": "Recent wins or projects",
    "tone": "How would you describe your tone?",
    "language": "Posts language",
    "postVoice": "Post voice",
    "founderName": "Founder name",
    "extraContext": "Anything else?",
    "skipForNow": "Skip for now",
    "saveAndCrawl": "Save and start crawling",
    "languageNl": "Nederlands",
    "languageEn": "English",
    "languageBoth": "Both",
    "voiceFounder": "As founder (I / we)",
    "voiceBrand": "As brand",
    "choosePlan": "Choose your plan",
    "trialActiveMessage": "Your {{days}}-day trial is active. Upgrade anytime from billing.",
    "continueToDashboard": "Continue to dashboard"
  },
  "invitations": {
    "youreInvited": "You're invited",
    "inviteMessage": "{{inviterName}} invited you to join {{workspaceName}} on Merkflow.",
    "expires": "Expires",
    "acceptInvitation": "Accept invitation",
    "signInToAccept": "Sign in to accept",
    "signInRedirect": "You'll be brought back here right after you sign in.",
    "notFound": "Invitation not found",
    "notFoundDescription": "We couldn't find this invitation. Double-check the link or ask whoever invited you to send a new one.",
    "expired": "This invitation has expired",
    "expiredDescription": "The link is no longer valid. Ask the workspace owner to send a fresh invite.",
    "alreadyAccepted": "Already accepted",
    "alreadyAcceptedDescription": "This invitation has already been accepted. Sign in and switch workspaces from the top bar.",
    "acceptFailed": "Could not accept invitation",
    "joining": "Joining…"
  },
  "ads": {
    "title": "Meta Marketing",
    "subtitle": "Create and manage campaigns across Facebook and Instagram.",
    "newCampaign": "New campaign",
    "createCampaign": "Create campaign",
    "noCampaigns": "Run your first Meta campaign",
    "noCampaignsDescription": "Create targeted ads on Facebook and Instagram using your existing posts or new creatives.",
    "campaignNotFound": "Campaign not found",
    "backToList": "Back to campaigns",
    "viewDetails": "View",
    "dailyBudget": "Daily budget",
    "dailyTrend": "Daily spend (last 30 days)",
    "noDailyData": "No daily data yet — the nightly sync runs at 04:30.",
    "syncsNightly": "Data refreshes nightly (04:30 UTC)",
    "notYetSynced": "Insights sync overnight for the first time.",
    "reconnectTitle": "Updated Meta permissions needed",
    "reconnectMeta": "Your Meta connection needs the new ads permissions to manage campaigns. Reconnect to enable campaign management.",
    "reconnect": "Reconnect Meta",
    "budgetHelper": "This budget is charged directly by Meta to your ad account. Merkflow does not charge for ad spend.",
    "deleteConfirmTitle": "Delete campaign?",
    "deleteConfirmBody": "This removes the campaign, ad sets, and creatives from Merkflow. The campaign stays live on Meta until you also stop it there.",
    "effectiveStatusTooltip": "Status as Meta currently reports it: {{status}}",
    "effectiveStatusDrift": "differed in Merkflow — just synced",
    "promoteThisPost": "Promote this post",
    "promote": {
      "title": "Promote post",
      "subtitle": "Boost this {{platform}} post to a wider audience",
      "budgetLabel": "Daily budget",
      "perDay": "per day",
      "durationLabel": "Duration",
      "days": "days",
      "countriesLabel": "Countries",
      "ageRange": "Age range",
      "paused": "The campaign is created in draft. Review it on the detail page before publishing — no money is spent yet.",
      "boost": "Boost",
      "creating": "Creating…",
      "genericError": "Promote failed. Check your Meta connection and try again."
    },
    "promoteGate": {
      "PROMOTE_POST_NOT_PUBLISHED": "Only published posts can be boosted.",
      "PROMOTE_POST_UNSUPPORTED_PLATFORM": "Boost is only available for Facebook and Instagram. LinkedIn posts can't be boosted through Merkflow.",
      "PROMOTE_POST_NO_EXTERNAL_ID": "This post wasn't published through Meta, so there's no Meta post id to boost.",
      "PROMOTE_POST_NO_COUNTRIES": "Pick at least one country to target.",
      "PUBLISH_NO_BUDGET": "Set a positive daily budget.",
      "MISSING_ADS_SCOPE": "Your Meta connection needs the new ads permissions. Reconnect Meta from the connections page."
    },
    "steps": {
      "objective": "Objective",
      "budget": "Budget",
      "audience": "Audience",
      "creative": "Creative"
    },
    "objectives": {
      "awareness": "Awareness",
      "awarenessDesc": "Show your brand to more people",
      "traffic": "Traffic",
      "trafficDesc": "Send people to your website",
      "engagement": "Engagement",
      "engagementDesc": "Get more likes, reactions and shares",
      "conversions": "Conversions",
      "conversionsDesc": "Get people to take action on your site"
    },
    "status": {
      "active": "Active",
      "draft": "Draft",
      "paused": "Paused",
      "completed": "Completed"
    },
    "metrics": {
      "spend": "Spend",
      "impressions": "Impressions",
      "reach": "Reach",
      "clicks": "Clicks",
      "cpm": "CPM",
      "ctr": "CTR"
    },
    "actions": {
      "publish": "Publish",
      "pause": "Pause",
      "delete": "Delete"
    },
    "ctas": {
      "LEARN_MORE": "Learn more",
      "SHOP_NOW": "Shop now",
      "SIGN_UP": "Sign up",
      "CONTACT_US": "Contact us",
      "DOWNLOAD": "Download"
    },
    "wizard": {
      "title": "New Meta campaign",
      "creating": "Creating…",
      "create": "Create campaign",
      "nameLabel": "Campaign name",
      "namePlaceholder": "e.g. Spring sale 2026",
      "brandLabel": "Brand",
      "brandNone": "No specific brand",
      "brandHint": "The brand this campaign is associated with — used for reporting and filtering.",
      "objectiveLabel": "What do you want to achieve?",
      "dailyBudgetLabel": "Daily budget",
      "perDay": "per day",
      "startDate": "Start date",
      "endDate": "End date",
      "endDateHint": "Leave empty to run continuously",
      "countriesLabel": "Countries",
      "countriesHint": "ISO codes separated by commas (NL, BE, DE)",
      "ageRange": "Age range",
      "platforms": "Platforms",
      "headlineLabel": "Headline",
      "headlinePlaceholder": "Short, punchy line",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Up to 125 characters — text below the headline",
      "imageUrlLabel": "Image URL",
      "ctaLabel": "Button",
      "preview": "Preview",
      "previewEmptyHeadline": "Enter a headline to see a preview",
      "missingScopeError": "Your Meta connection no longer has ads permissions. Reconnect Meta from the connections page.",
      "genericError": "Could not create campaign. Try again or check your Meta connection."
    },
    "publishGate": {
      "generic": {
        "title": "Can't publish yet",
        "body": "Check the campaign configuration before publishing."
      },
      "PUBLISH_NOT_SYNCED": {
        "title": "Campaign not synced to Meta yet",
        "body": "This campaign wasn't created on Meta — likely an error during the first sync. Re-create it via the wizard."
      },
      "PUBLISH_NO_BUDGET": {
        "title": "Set a daily budget",
        "body": "Meta can't deliver ads without a daily budget. Add one and publish again."
      },
      "PUBLISH_NO_AD_SETS": {
        "title": "Add at least one ad set",
        "body": "A campaign with no ad sets can't run. Open the campaign in Meta Ads Manager to add one — or re-create it via the wizard."
      },
      "PUBLISH_NO_CREATIVES": {
        "title": "Add at least one creative",
        "body": "There are ad sets but no creatives. Add an image or post before publishing."
      },
      "PUBLISH_BILLING_NOT_CONFIGURED": {
        "title": "Configure your Meta payment method first",
        "body": "Your Meta ad account has no payment method yet. Open Meta Business Manager → Billing and add one — Merkflow doesn't charge for ad spend, everything goes through Meta directly."
      },
      "PUBLISH_AD_ACCOUNT_DISABLED": {
        "title": "Your Meta ad account is disabled",
        "body": "Meta has paused or restricted your ad account. Open Meta Business Manager to see the status and appeal."
      }
    }
  },
  "calendar": {
    "title": "Calendar",
    "subtitle": "Real posts and projected cadence slots for this month",
    "prevMonth": "Previous month",
    "nextMonth": "Next month",
    "published": "Published",
    "scheduledDraft": "Scheduled draft",
    "cadenceSlot": "Cadence slot (will generate)",
    "nothingScheduled": "Nothing scheduled or projected for this day.",
    "projectedCadenceSlots": "Projected cadence slots",
    "willGeneratePost": "Merkflow will generate a {{platform}} post for {{brandName}} at {{time}}",
    "cadenceSlotTitle": "Cadence slot — {{platform}}",
    "scheduled": "Scheduled"
  },
  "discover": {
    "title": "Discover",
    "subtitle": "Trending topics, hashtags, and content ideas for your brands.",
    "upgrade": {
      "title": "Trending content is a paid feature",
      "body": "Discover surfaces weekly trending topics + hashtags + AI-generated content ideas tailored to each brand. Available on plans that include trending content discovery."
    },
    "staleData": "Last updated over 24h ago — click Refresh to update.",
    "allBrands": "All brands",
    "updatedTime": "Updated {{time}}",
    "sourceLabel": "Source: {{source}}",
    "refreshing": "Refreshing...",
    "trendingHashtags": "Trending hashtags",
    "noTrendingData": "No trending data yet. Add brands with onboarding profiles, then click Refresh.",
    "clickToCopy": "Click to copy",
    "contentIdeas": "Content ideas",
    "noIdeas": "No content ideas yet",
    "noIdeasDescription": "Complete your brand onboarding profiles, then click Refresh to generate AI-powered content suggestions.",
    "marketIntelligence": "Market intelligence",
    "marketIntelligenceDescription": "Competitors you're up against and how AI search engines see them next to you.",
    "viewFullAnalysis": "View full analysis",
    "generatePost": "Generate post →"
  },
  "storyline": {
    "title": "Storylines",
    "subtitle": "Narrative arcs that build toward a goal — product launches, campaigns, announcements.",
    "new": "New Storyline",
    "allBrands": "All brands",
    "noStorylines": "No storylines yet",
    "emptyDescription": "Create a storyline to plan a narrative arc — like a product launch countdown or a campaign build-up.",
    "deleteConfirm": "Archive this storyline? Posts will be unlinked but not deleted.",
    "delete": "Archive storyline",
    "permanentDelete": "Delete permanently",
    "permanentDeleteTitle": "Delete this storyline permanently?",
    "permanentDeleteConfirm": "This cannot be undone. Linked posts will lose their storyline reference but stay published.",
    "target": "Target: {{date}}",
    "noDate": "No date",
    "noContentYet": "No content yet",
    "mediaAttached": "📎 {{type}} attached",
    "daysLeft_one": "{{count}} day left",
    "daysLeft_other": "{{count}} days left",
    "postsProgress": "{{published}}/{{total}} posts",
    "rebuildPosts": "Rebuild posts",
    "publishedPosts_one": "{{published}} / {{total}} post published",
    "publishedPosts_other": "{{published}} / {{total}} posts published",
    "targetDays": "Target: {{date}} ({{days}} days)",
    "noPostsYet": "No posts in this storyline yet. The arc may still be generating.",
    "openInReview": "Open in review →",
    "notFound": "Storyline not found.",
    "stepN": "Step {{step}} of 3",
    "brand": "Brand",
    "name": "Storyline name",
    "namePlaceholder": "e.g. Product Launch Countdown",
    "goal": "Goal (optional)",
    "goalPlaceholder": "e.g. Build anticipation for our new bidding engine launch",
    "targetDate": "Target date",
    "platforms": "Platforms",
    "generateArc": "Generate arc →",
    "generatingArc": "Generating arc...",
    "proposedArc": "Proposed arc — {{count}} posts",
    "reviewSummary": "Review summary →",
    "confirm": "Confirm and create",
    "confirmDescription_one": "{{count}} post will be created and added to your review inbox.",
    "confirmDescription_other": "{{count}} posts will be created and added to your review inbox."
  },
  "blog": {
    "titleLabel": "Blog Posts",
    "subtitle": "AI-generated blog posts for your brands' WordPress sites. Approve to publish.",
    "write": "Write blog",
    "generate": "Generate blog",
    "allBrands": "All brands",
    "allStatuses": "All statuses",
    "pendingReview": "Pending review",
    "approved": "Approved",
    "rejected": "Rejected",
    "showRejected": "Show rejected",
    "noPostsYet": "No blog posts yet",
    "emptyDescription": "Blog posts are generated weekly for brands with WordPress connections. Connect WordPress in your brand settings to get started.",
    "words": "{{count}} words",
    "preview": "Preview",
    "hideContent": "Hide content",
    "showContent": "Show full content",
    "approvePublish": "Approve & Publish",
    "reject": "Reject",
    "regenerate": "Regenerate",
    "fieldTitle": "Title",
    "focusKeyword": "Focus keyword",
    "focusKeywordExample": "e.g. social media management",
    "metaDescription": "Meta description",
    "metaDescriptionPlaceholder": "SEO description (160 chars)",
    "content": "Content",
    "titlePlaceholder": "Blog post title...",
    "contentPlaceholder": "Start writing your blog post... Use the toolbar for headings, lists, images.",
    "editorPlaceholder": "Start writing your blog post...",
    "heading2": "Heading 2",
    "heading3": "Heading 3",
    "bulletList": "Bullet list",
    "numberedList": "Numbered list",
    "addLink": "Add link",
    "uploadImage": "Upload image",
    "wordCount": "{{count}} words",
    "generateBlogPost": "Generate blog post",
    "generateSubtitle": "AI writes an SEO-optimized blog post using your brand's knowledge",
    "topic": "Topic (optional)",
    "topicPlaceholder": "Leave empty for AI to choose based on brand knowledge",
    "customInstructions": "Additional instructions (optional)",
    "customInstructionsHelper": "E.g. writing style, angle, specific points to cover, or audience nuance.",
    "customInstructionsCharCount": "{{count}} / {{max}}",
    "language": "Language",
    "languageBothHint": "This brand writes in both languages. Pick which one for THIS blog post.",
    "generateHint": "The AI uses your brand's onboarding profile and crawled knowledge to write a 1000-1500 word blog post with SEO focus keyword and meta description.",
    "writing": "Writing blog post...",
    "generationEta": "30-60 seconds",
    "genFailed": "Generation failed",
    "writeBlogPost": "Write blog post",
    "writeSubtitle": "Create a blog post manually — ready to publish to WordPress",
    "saveFailed": "Failed to save",
    "saveBlogPost": "Save blog post",
    "coverImage": "Cover image (optional)",
    "coverImagePickerCta": "Drop an image here or click to upload",
    "coverImageHint": "Used as the post's hero on the blog archive. If you skip this, the brand's default image is used.",
    "coverImageTypeError": "That file isn't an image.",
    "coverImageUploadFailed": "Upload failed — try again.",
    "coverImageUploadCta": "Upload",
    "coverImageGenerateCta": "Generate with AI",
    "coverImageGenerating": "Generating cover with fal.ai (~15s)…",
    "coverImageGenerateFailed": "AI cover generation failed — try again or upload one yourself.",
    "shortDescription": "Short description (optional)",
    "shortDescriptionPlaceholder": "1–2 sentences shown under the post title on the blog archive…",
    "shortDescriptionHint": "Overrides the auto-generated excerpt. Keep it tight — about 240 characters.",
    "wordpress": "WordPress",
    "connectToPublish": "Connect to publish blog posts",
    "disconnectConfirm": "Disconnect WordPress?",
    "siteUrl": "WordPress site URL",
    "siteUrlExample": "https://www.merkflow.eu",
    "username": "Application username",
    "usernamePlaceholder": "Your WordPress login username (not display name)",
    "usernameHint": "Found at WP Admin → Users → your profile → Username field at the top",
    "password": "Application password",
    "passwordPlaceholder": "xxxx xxxx xxxx xxxx xxxx xxxx",
    "passwordHint": "WP Admin → Users → Profile → Application Passwords → Add New. Spaces are optional — paste it as WordPress shows it.",
    "connectionFailed": "Connection failed",
    "saveVerify": "Save & verify",
    "wpError": {
      "authHeaderStripped": "Your WordPress server is stripping the Authorization header",
      "authHeaderStrippedHelp": "Apache and some managed hosts drop the Authorization header before PHP can read it, so WordPress sees your request as anonymous. Paste this into your site's .htaccess file, above the '# BEGIN WordPress' block, and try again:",
      "wrongCredentials": "Wrong username or application password",
      "wrongCredentialsHelp": "Use your WordPress login username (not your email). The password must be a 24-character Application Password — not your regular login password. Generate one at WP Admin → Users → your profile → Application Passwords.",
      "notFound": "WordPress REST API not found at that URL",
      "notFoundHelp": "Make sure the site URL starts with https:// and points at your WordPress homepage (no /wp-admin, no trailing slash). If REST is disabled by a security plugin, re-enable it for authenticated users.",
      "pluginBadToken": "The Merkflow plugin rejected this token",
      "pluginNotInstalled": "Merkflow plugin not found on that site",
      "pluginInvalidToken": "Token looks too short",
      "pluginUnknown": "Could not reach the Merkflow plugin"
    },
    "connection": {
      "chooserSubtitle": "Pick how Merkflow talks to your WordPress site",
      "prosLabel": "Pros",
      "consLabel": "Cons",
      "pluginTitle": "Merkflow plugin",
      "pluginSubtitle": "Token-authenticated connection with full features",
      "pluginBestFor": "Best for: AI search visibility, full feature set",
      "pluginPro1": "Real /llms.txt at site root, served as plain text",
      "pluginPro2": "Publish blog posts and cover images",
      "pluginPro3": "No WordPress user account or password needed",
      "pluginCon1": "One-time plugin install (zip upload + activate in WP admin)",
      "pluginCon2": "Plugin must stay active — deactivating breaks the connection",
      "pluginButton": "Connect via plugin",
      "pluginBadge": "Plugin",
      "pluginBadgeTooltip": "Connected via the Merkflow companion plugin — full feature support.",
      "apiKeyTitle": "Application Password",
      "apiKeySubtitle": "Connect with a WordPress Application Password",
      "apiKeyBestFor": "Best for: blog publishing only, no plugin install possible",
      "apiKeyPro1": "Works on any WordPress site — no plugin to install",
      "apiKeyPro2": "Standard WordPress mechanism, granular user permissions",
      "apiKeyPro3": "Can be revoked instantly from WP user profile",
      "apiKeyCon1": "Can't publish a real /llms.txt — AI search visibility limited",
      "apiKeyCon2": "Some hosts strip the auth header (.htaccess fix needed)",
      "apiKeyButton": "Connect via API key",
      "apiKeyBadge": "API key",
      "apiKeyBadgeTooltip": "Connected via WordPress Application Password — llms.txt is unavailable in this mode.",
      "apiKeyTradeoffTooltip": "WordPress doesn't let API connections create real /llms.txt files. Use the Merkflow plugin if AI search visibility matters.",
      "apiKeyTradeoffTitle": "Heads up — limited mode",
      "apiKeyTradeoffBody": "Application Password connections can publish blog posts, but can't generate a spec-compliant /llms.txt at your site root. Switch to plugin mode if AI search visibility is a goal.",
      "installSteps": "Install the Merkflow plugin first",
      "installStep1": "Download the plugin from your Merkflow account team or build from merkflow-wp-plugin/",
      "installStep2": "WP Admin → Plugins → Add New → Upload Plugin → Activate",
      "installStep3": "Settings → Merkflow → Generate token, paste below",
      "tokenLabel": "Connection token",
      "tokenPlaceholder": "Paste the token shown after generating in WP Admin",
      "tokenHint": "Shown only once after you click 'Generate token' in WP Admin → Settings → Merkflow. Generate a new one if you've lost it — it invalidates the old one.",
      "testButton": "Test connection",
      "testOk": "Plugin reachable, token accepted",
      "testFailed": "Test failed",
      "saveButton": "Save & connect"
    }
  },
  "blogAnalytics": {
    "noDataYet": "No blog traffic yet",
    "noDataHint": "The WP plugin collects page-view stats once visitors land on a blog post. Sync runs nightly at 03:30 UTC.",
    "totalViews": "Total views",
    "totalViews30d": "Views (last 30 days)",
    "uniqueVisitors": "unique visitors",
    "aiTrafficPct": "AI traffic share",
    "aiTraffic": "AI traffic",
    "aiVisits": "visits from AI assistants",
    "topPost": "Top post",
    "views": "views",
    "noPostsYet": "No posts ranked yet",
    "tabHeroTitle": "Blog page views",
    "pickBrandTitle": "Select a brand",
    "pickBrandHint": "Blog analytics are per brand. Pick a brand above to see its page-view stats.",
    "postsWithViews": "Posts with views",
    "referrerTitle": "Where traffic comes from",
    "deviceTitle": "Devices",
    "topPostsTitle": "Top posts",
    "latestDayHint": "Latest day in range",
    "postRef": "Post #{{id}}",
    "ref": {
      "ai": "AI assistants",
      "search": "Search",
      "social": "Social",
      "direct": "Direct",
      "internal": "Internal",
      "other": "Other"
    },
    "device": {
      "desktop": "Desktop",
      "mobile": "Mobile",
      "bot": "Bots"
    }
  },
  "adminPlans": {
    "marketingCopy": "Marketing copy",
    "nameEn": "Name (EN)",
    "nameNl": "Name (NL)",
    "taglineEn": "Tagline (EN)",
    "taglineNl": "Tagline (NL)",
    "title": "Plans",
    "subtitle": "Source of truth for tier limits, prices, and feature flags. The Merkflow app enforces these in real time — www.merkflow.eu/pricing just displays what you set here.",
    "sourceOfTruth": "Source of truth",
    "sourceOfTruthBody": "This page decides every plan limit, price, and feature flag for the Merkflow app. The WordPress pricing page reads the same values over /api/public/plans and renders them — it never diverges from what you set here.",
    "livePreviewLabel": "Live preview",
    "livePreviewLink": "www.merkflow.eu/pricing ↗",
    "cacheLoadedAt": "Cache loaded {{time}}",
    "notPublic": "Not public",
    "saving": "saving",
    "monthlyPriceEur": "Monthly price (EUR)",
    "priceCaption": "New subscribers only. Existing subscribers keep their current price until they change plans (Mollie subscriptions are immutable on amount).",
    "trialDurationDays": "Trial duration",
    "daysSuffix": "days",
    "trialDurationCaption": "Stored in system_settings.trial_duration_days. Changing this updates new signups + the /pricing trial chip. Existing trials keep their already-stamped end date.",
    "aiModelTier": "AI model tier",
    "aiModelHaiku": "Haiku (fast, cheap)",
    "aiModelSonnet": "Sonnet (balanced)",
    "aiModelOpus": "Opus (premium)",
    "limitsSection": "Limits",
    "featuresSection": "Features",
    "limitLabelWorkspaces": "Workspaces",
    "limitLabelBrandsPerWorkspace": "Brands / workspace",
    "limitLabelPlatforms": "Platforms",
    "limitLabelTeamMembers": "Team members",
    "limitLabelApiKeys": "API keys",
    "limitLabelPostsPerMonth": "Posts / month",
    "limitLabelCarouselsPerMonth": "Carousels / month",
    "limitLabelImagesPerMonth": "Images / month",
    "unlimited": "Unlimited",
    "unlimitedClickToSet": "Click to set a numeric limit",
    "numericSetToUnlimited": "Set to unlimited",
    "loadingState": "Loading plan config…",
    "loadError": "Could not load plan config. {{message}}",
    "public": "Public",
    "visibilityHidePricing": "Hide from public pricing page",
    "visibilityShowPricing": "Show on public pricing page",
    "limitLabelReelsNoAudio": "Reels / month (no audio)",
    "limitLabelReelsWithAudio": "Reels with audio / month",
    "tabTiers": "Tiers",
    "tabTopups": "Top-ups",
    "recommendation": {
      "openLabel": "View recommendation",
      "deprecated": "Deprecated",
      "inactive": "Inactive",
      "recommendedTiers": "Recommended for",
      "reasoning": "Why",
      "recommendedFor": "Recommended for {{tier}}",
      "noTierEntry": "No specific recommendation for {{tier}}",
      "allTiers": "All tiers"
    },
    "warnings": {
      "healthy": "Configuration looks healthy",
      "dismiss": "Dismiss",
      "dismissHint": "Hide for this session (no persistence yet)"
    },
    "cost": {
      "estimated": "Est. cost",
      "perMonth": "/ month at cap",
      "margin": "margin",
      "marginHint": "Margin = (price €{{price}} − estimated cost) / price. Estimate uses unit costs from UnitCosts.kt.",
      "noMargin": "No margin (free tier)"
    }
  },
  "topup": {
    "pickerTitle": "Need more capacity?",
    "pickerSubtitle": "You've hit your {{limitName}} allowance for this month. Buy extra units mid-month — no upgrade needed.",
    "planLimitTitle": "Plan limit reached",
    "planLimitSubtitle": "Your {{plan}} plan doesn't include more {{limitName}}.",
    "planLimitBody": "Upgrade to unlock higher {{limitName}} allowances — no mid-month top-up covers structural limits like this.",
    "upgradePlan": "Upgrade plan →",
    "processingHint": "After payment, it takes ~30 seconds for the balance to show up. You'll see a confirmation on the billing page.",
    "sectionTitle": "Extra capacity",
    "sectionSubtitle": "Bought packs never expire for 12 months. Oldest pack drains first (FIFO).",
    "requiresPaidPlan": "Extra capacity is only available on a paid plan. Upgrade to Starter, Pro, or Agency to buy top-ups.",
    "processingTitle": "Payment processing",
    "processingBody": "Your balance will update within about a minute once Mollie confirms the payment. No need to refresh.",
    "balanceLabel_one": "You have {{count}} left",
    "balanceLabel_other": "You have {{count}} left",
    "resourcePosts": "AI posts",
    "resourcePostsHaiku": "Haiku posts",
    "resourcePostsSonnet": "Sonnet posts",
    "resourcePostsOpus": "Opus posts",
    "resourceImages": "AI images",
    "resourceReelsNoAudio": "Reels (no audio)",
    "resourceReelsWithAudio": "Reels with audio",
    "resourceCarousels": "Carousels",
    "resourceBrands": "Brands",
    "resourcePlatforms": "Platforms",
    "resourceTeamMembers": "Team members",
    "resourceApiKeys": "API keys"
  },
  "adminTopups": {
    "loadError": "Could not load top-up packs. {{message}}",
    "unitsLabel": "Units",
    "priceLabel": "Price €",
    "unitCostLabel": "Unit cost €",
    "marginPercent": "margin {{percent}}%",
    "marginOkTooltip": "Above the 30% target — good.",
    "marginWarnTooltip": "Below the 30% margin target. Raise the price or lower the unit count to stay profitable.",
    "groupPostsHaiku": "Posts — Haiku",
    "groupPostsSonnet": "Posts — Sonnet",
    "groupPostsOpus": "Posts — Opus",
    "groupImages": "Images",
    "groupReelsNoAudio": "Reels — no audio",
    "groupReelsWithAudio": "Reels — with audio",
    "groupCarousels": "Carousels"
  },
  "admin": {
    "users": {
      "role": "Role",
      "access": "Access",
      "admin": "Admin",
      "user": "User",
      "promote": "Promote to admin",
      "promoteTitle": "Promote to admin?",
      "promoteConfirm": "Give {{email}} full platform admin access? They will be able to manage every workspace, every user, and every billing setting.",
      "demote": "Remove admin access",
      "demoteTitle": "Remove admin access?",
      "demoteConfirm": "Remove platform admin access from {{email}}? They will lose access to /admin and become a regular user.",
      "suspend": "Suspend account",
      "suspendTitle": "Suspend this account?",
      "suspendConfirm": "Suspend {{email}}? They will be signed out and cannot sign back in until you unsuspend.",
      "unsuspend": "Unsuspend account",
      "lastAdmin": "Cannot remove admin access — there must be at least one admin.",
      "roleUpdated": "Role updated.",
      "roleUpdateFailed": "Failed to update role.",
      "statusUpdated": "Status updated.",
      "statusUpdateFailed": "Failed to update status."
    },
    "inviteLinks": {
      "title": "Invite links",
      "subtitle": "Generate beta tester signup URLs. Each link creates a workspace on the chosen plan with plan_override = true.",
      "create": "Create invite link",
      "created": "Created. URL copied to clipboard.",
      "copyUrl": "Copy URL",
      "copied": "URL copied",
      "disable": "Disable",
      "disabled": "Disabled.",
      "disableFailed": "Disable failed.",
      "confirmDisableTitle": "Disable this invite link?",
      "confirmDisableMessage": "Code {{code}} will stop accepting new redemptions. Existing redeemed users keep their accounts.",
      "plan": "Plan",
      "maxUsesLabel": "Max signups via this link (blank = unlimited)",
      "maxUsesPlaceholder": "e.g. 10 — leave empty for unlimited",
      "expiresLabel": "Expires (blank = never)",
      "never": "Never",
      "stateActive": "Active",
      "stateExpired": "Expired",
      "stateMaxed": "Maxed out",
      "stateDisabled": "Disabled",
      "redemptionsTitle": "Redemptions",
      "noRedemptions": "Nobody has redeemed this link yet.",
      "colCode": "Code",
      "colPlan": "Plan",
      "colUses": "Uses",
      "colExpires": "Expires",
      "colCreated": "Created",
      "colStatus": "Status",
      "colActions": "Actions",
      "empty": {
        "title": "No invite links yet",
        "description": "Create one to share a signup URL with beta testers."
      }
    },
    "feedback": {
      "title": "Feedback",
      "subtitle": "Bug reports, feature requests, and questions submitted by beta testers.",
      "entriesCount_one": "{{count}} entry",
      "entriesCount_other": "{{count}} entries",
      "categoryAll": "All categories",
      "statusNew": "New",
      "statusAcknowledged": "Acknowledged",
      "statusResolved": "Resolved",
      "statusWont_fix": "Won't fix",
      "statusAll": "All",
      "status": "Status",
      "screenshot": "Screenshot",
      "adminNotes": "Admin notes",
      "updated": "Saved.",
      "updateFailed": "Update failed.",
      "markResolved": "Mark resolved",
      "markedResolved": "Marked resolved.",
      "delete": "Delete",
      "deleted": "Deleted.",
      "deleteFailed": "Delete failed.",
      "widgetSection": "Feedback widget",
      "widgetOnHint": "On — the floating Feedback button is visible to everyone on every dashboard page.",
      "widgetOffHint": "Off — the floating Feedback button is hidden for everyone. Submissions are also rejected server-side.",
      "widgetEnabled": "Feedback widget enabled.",
      "widgetDisabled": "Feedback widget disabled.",
      "toggleFailed": "Could not update widget setting.",
      "confirmDeleteTitle": "Delete this feedback?",
      "confirmDeleteMessage": "Permanently delete \"{{title}}\"? Screenshot in S3 stays — only the DB row is removed.",
      "descriptionLabel": "Description",
      "notesPlaceholder": "Internal notes — visible to admins only.",
      "notFound": "This feedback no longer exists.",
      "backToList": "Back to feedback",
      "dangerZone": "Danger zone",
      "colCategory": "Category",
      "colTitle": "Title",
      "colPage": "Page",
      "colStatus": "Status",
      "colSubmitted": "Submitted",
      "empty": {
        "title": "No feedback yet",
        "description": "Beta testers' submissions appear here. Use the Feedback button on dashboard pages to submit one yourself."
      }
    },
    "waitlist": {
      "title": "Waitlist",
      "subtitle": "Approve or reject access requests submitted while the registration gate is closed.",
      "searchPlaceholder": "Search by email or name…",
      "entriesCount_one": "{{count}} entry",
      "entriesCount_other": "{{count}} entries",
      "statusPending": "Pending",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "statusAll": "All",
      "approve": "Approve",
      "reject": "Reject",
      "approveSelected_one": "Approve {{count}} entry",
      "approveSelected_other": "Approve {{count}} entries",
      "bulkApprove": "Bulk approve",
      "approveSuccess": "Approved. Email sent.",
      "approveFailed": "Approval failed.",
      "rejectSuccess": "Rejected.",
      "rejectFailed": "Reject failed.",
      "bulkApproveSuccess": "Approvals processed. Emails sent.",
      "confirmRejectTitle": "Reject this request?",
      "confirmRejectMessage": "Reject access for {{email}}? They won't be notified — they can resubmit later if they want to.",
      "confirmBulkApproveTitle": "Approve all selected?",
      "confirmBulkApproveMessage": "Approve {{count}} pending requests and send each one an approval email?",
      "approvedOn": "Approved {{date}}",
      "colEmail": "Email",
      "colName": "Name",
      "colCompany": "Company",
      "colUseCase": "Use case",
      "colSubmitted": "Submitted",
      "colStatus": "Status",
      "colActions": "Actions",
      "empty": {
        "title": "No requests yet",
        "description": "Waitlist entries appear here when registration is closed and visitors fill out the request form."
      }
    },
    "create": {
      "button": "Create user",
      "title": "Create a new user",
      "subtitle": "Provision an account directly. Bypasses the registration gate.",
      "fieldEmail": "Email",
      "fieldName": "Full name",
      "fieldPassword": "Password (optional)",
      "passwordPlaceholder": "Leave blank for OAuth-only",
      "passwordHint": "Min. 8 characters. Leave empty if the user will only sign in with Google or LinkedIn.",
      "fieldPlan": "Plan",
      "skipOnboarding": "Skip onboarding (creates a workspace immediately)",
      "submit": "Create user",
      "success": "User created.",
      "duplicate": "An account with that email already exists.",
      "failed": "Failed to create user."
    },
    "gate": {
      "title": "Public registration",
      "statusOpen": "New users can sign up via the website.",
      "statusClosed": "Signups are blocked. Existing users and invited team members are not affected.",
      "actionClose": "Close registration",
      "actionOpen": "Open registration",
      "confirmCloseTitle": "Close public registration?",
      "confirmCloseMessage": "New users will not be able to register. Existing users and invited team members are not affected.",
      "confirmCloseAction": "Yes, close",
      "toastClosed": "Registration is now closed.",
      "toastOpen": "Registration is now open.",
      "updateFailed": "Failed to update registration setting."
    }
  },
  "connectedApps": {
    "integrationsTitle": "Native integrations",
    "integrationsSubtitle": "Slack and Discord channels receive formatted notifications for every event you subscribe.",
    "webhooksTitle": "Custom webhooks",
    "webhooksSubtitle": "Subscribe a URL of your choosing to Merkflow events. HMAC-signed payloads, auto-disable after repeated failures.",
    "emailTitle": "Outgoing email",
    "emailSubtitle": "Per-workspace SMTP for invitations + automated emails.",
    "ownerOnly": "Owner-only — ask a workspace owner to connect this.",
    "events": {
      "post_published": "Post published",
      "post_failed": "Post failed",
      "post_approved": "Post approved",
      "engagement_new_comment": "New comment or mention",
      "engagement_auto_replied": "Auto-response sent",
      "cadence_generated": "Weekly posts ready",
      "report_ready": "Report generated",
      "connection_unhealthy": "Platform connection issue"
    },
    "webhook": {
      "add": "Add webhook",
      "addTitle": "Add custom webhook",
      "editTitle": "Edit webhook",
      "subtitle": "POST events to a URL of your choosing.",
      "nameLabel": "Name",
      "nameCaption": "Internal label only. Not sent to your endpoint.",
      "namePlaceholder": "My CRM webhook",
      "urlLabel": "URL",
      "urlCaption": "Receiver must accept POST with application/json. 10-second timeout.",
      "secretLabel": "HMAC secret (optional)",
      "secretCaption": "When set, we sign every payload with HMAC-SHA256 in the X-Merkflow-Signature header. Leave blank to skip signing.",
      "secretEmptyPlaceholder": "Optional — leave blank to skip HMAC signing",
      "secretPresentPlaceholder": "Already configured — type to replace, leave blank to keep",
      "eventsLabel": "Events",
      "eventsCaption": "Pick the events your receiver wants. We never POST events you didn't subscribe to.",
      "test": "Test",
      "testSuccessToast": "Test event delivered — HTTP {{status}}",
      "testFailedStatusToast": "Test event returned HTTP {{status}}",
      "testFailedToast": "Test event failed to deliver.",
      "savedToast": "Webhook updated.",
      "createdToast": "Webhook created.",
      "saveFailedToast": "Failed to save webhook.",
      "removedToast": "Webhook removed.",
      "removeFailedToast": "Failed to remove webhook.",
      "removeConfirm": "Remove webhook \"{{name}}\"? Deliveries stop immediately.",
      "viewDeliveries": "Deliveries",
      "lastTriggered": "Last triggered {{time}}",
      "neverTriggered": "Never triggered",
      "secretConfigured": "HMAC signature configured",
      "noEvents": "No events subscribed yet",
      "disabledPill": "Disabled",
      "autoDisabledTitle": "Auto-disabled",
      "autoDisabledBody": "Disabled after {{count}} consecutive failures. Fix your endpoint and re-enable to resume.",
      "reenable": "Re-enable",
      "reenabledToast": "Webhook re-enabled.",
      "emptyTitle": "No custom webhooks yet",
      "emptyBody": "Add a webhook to receive Merkflow events at your own URL — useful for Zapier, n8n, Make, or a custom integration."
    },
    "integration": {
      "label": "Integration",
      "setupSteps": "How to set up",
      "urlLabel": "Webhook URL",
      "urlCaption": "Paste the incoming-webhook URL from your team's app. We never echo this back.",
      "urlEditCaption": "Stored URL ends in {{masked}}. Leave blank to keep it; paste a new one to replace.",
      "channelLabel": "Channel label (optional)",
      "channelCaption": "Helps you identify which channel is which on this page.",
      "eventsCount": "Events subscribed",
      "noneSubscribed": "None — subscribe events to receive notifications",
      "eventsCaption": "Pick the events you want delivered to this channel.",
      "removeConfirm": "Remove the {{name}} integration? Notifications stop immediately.",
      "connect": "Connect",
      "savedToast": "Integration updated.",
      "connectedToast": "Integration connected.",
      "saveFailedToast": "Failed to save integration.",
      "removedToast": "Integration removed.",
      "removeFailedToast": "Failed to remove integration.",
      "testSentToast": "Test event sent — check your channel.",
      "testFailedToast": "Test event failed to send.",
      "slack": {
        "description": "Post notifications to a Slack channel via an incoming webhook. Free for any Slack workspace.",
        "connect": "Connect Slack",
        "connectTitle": "Connect Slack",
        "editTitle": "Edit Slack integration",
        "subtitle": "Notify a Slack channel for every event you pick.",
        "step1": "Open api.slack.com/apps, create a new app, enable Incoming Webhooks.",
        "step2": "Add a webhook to the channel you want notifications in.",
        "step3": "Copy the URL Slack gives you and paste it below."
      },
      "discord": {
        "description": "Post notifications to a Discord channel via an incoming webhook. Free for any Discord server.",
        "connect": "Connect Discord",
        "connectTitle": "Connect Discord",
        "editTitle": "Edit Discord integration",
        "subtitle": "Notify a Discord channel for every event you pick.",
        "step1": "In Discord: open Server Settings → Integrations → Webhooks → New Webhook.",
        "step2": "Pick the channel, give the bot a name, optionally a custom avatar.",
        "step3": "Copy the webhook URL and paste it below."
      }
    },
    "deliveries": {
      "title": "Recent deliveries",
      "empty": "No deliveries yet. Send a test event or wait for the next subscribed event.",
      "deliveredAtLabel": "Delivered at",
      "responseBodyLabel": "Response body"
    }
  }
}
